var yo = Object.defineProperty;
var Nr = (e) => {
  throw TypeError(e);
};
var bo = (e, t, r) => t in e ? yo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var _ = (e, t, r) => bo(e, typeof t != "symbol" ? t + "" : t, r), qr = (e, t, r) => t.has(e) || Nr("Cannot " + r);
var w = (e, t, r) => (qr(e, t, "read from private field"), r ? r.call(e) : t.get(e)), j = (e, t, r) => t.has(e) ? Nr("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), P = (e, t, r, n) => (qr(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r);
import { defineComponent as He, computed as Q, resolveComponent as go, createElementBlock as fe, openBlock as Z, normalizeClass as It, createBlock as Rn, createCommentVNode as Pt, renderSlot as Dr, createElementVNode as J, toDisplayString as rt, reactive as _n, unref as wo, mergeModels as Tn, useModel as In, createVNode as Ye } from "vue";
import { cloneDeep as vo, isEqual as Eo, sortBy as So } from "lodash";
import Lr from "mustache";
const Co = ["disabled", "type"], xo = {
  key: 1,
  class: "base-btn__icon-container",
  "data-testid": "button-icon"
}, Oo = ["src"], Ao = /* @__PURE__ */ He({
  __name: "BaseButton",
  props: {
    icon: { default: "" },
    text: { default: "" },
    variant: { default: "accent" },
    shape: { default: "rounded" },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    uppercase: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    type: { default: "submit" },
    borderRadius: { default: "xs" },
    isSubmitting: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = Q(() => {
      const s = "base-btn", o = [
        `${s}--${t.variant}`,
        `${s}--size-${t.size}`,
        `${s}--${t.shape}`,
        `${s}--border-radius-${t.borderRadius}`
      ];
      return t.disabled && o.push(`${s}--disabled`), t.fullWidth && o.push(`${s}--full-width`), t.active && o.push(`${s}--active`), o;
    }), n = Q(() => t.uppercase ? ["base-btn__text--uppercase"] : []);
    return (s, o) => {
      const i = go("b-spinner");
      return Z(), fe("button", {
        class: It([r.value, "base-btn"]),
        disabled: s.disabled,
        "data-testid": "button",
        type: s.type
      }, [
        s.isSubmitting ? (Z(), Rn(i, {
          key: 0,
          class: "base-btn__spinner"
        })) : s.icon || s.$slots.icon ? (Z(), fe("span", xo, [
          Dr(s.$slots, "icon", {}, () => [
            J("img", {
              src: s.icon,
              class: "base-btn__icon",
              alt: ""
            }, null, 8, Oo)
          ], !0)
        ])) : Pt("", !0),
        Dr(s.$slots, "default", {}, () => [
          s.text ? (Z(), fe("span", {
            key: 0,
            class: It(n.value),
            "data-testid": "button-text"
          }, rt(s.text), 3)) : Pt("", !0)
        ], !0)
      ], 10, Co);
    };
  }
}), gt = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, s] of t)
    r[n] = s;
  return r;
}, Ro = /* @__PURE__ */ gt(Ao, [["__scopeId", "data-v-41e566fd"]]), _o = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.0355%2013.8494L10.5725%206.29024H13.4274L12.9452%2013.8494H11.0355Z'%20fill='%231D1D1D'/%3e%3cpath%20d='M12.0161%2017.7097C11.6392%2017.7097%2011.3269%2017.5859%2011.0793%2017.3382C10.8316%2017.0906%2010.7078%2016.7944%2010.7078%2016.4499C10.7078%2016.1053%2010.8316%2015.8145%2011.0793%2015.5776C11.3269%2015.33%2011.6392%2015.2062%2012.0161%2015.2062C12.393%2015.2062%2012.6999%2015.33%2012.9368%2015.5776C13.1737%2015.8145%2013.2921%2016.1053%2013.2921%2016.4499C13.2921%2016.7944%2013.1737%2017.0906%2012.9368%2017.3382C12.6999%2017.5859%2012.393%2017.7097%2012.0161%2017.7097Z'%20fill='%231D1D1D'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M12%2022C17.5228%2022%2022%2017.5228%2022%2012C22%206.47715%2017.5228%202%2012%202C6.47715%202%202%206.47715%202%2012C2%2017.5228%206.47715%2022%2012%2022ZM12%2021.0625C17.0051%2021.0625%2021.0625%2017.0051%2021.0625%2012C21.0625%206.99492%2017.0051%202.9375%2012%202.9375C6.99492%202.9375%202.9375%206.99492%202.9375%2012C2.9375%2017.0051%206.99492%2021.0625%2012%2021.0625Z'%20fill='%231D1D1D'/%3e%3c/svg%3e", Pn = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
  const t = Math.random() * 16 | 0;
  return (e == "x" ? t : t & 3 | 8).toString(16);
}), jn = `error-${Pn()}`, To = (e) => {
  const t = (e || document).querySelector(
    `[id^=${jn}]`
  );
  t == null || t.scrollIntoView({
    behavior: "smooth"
  });
}, Io = () => ({
  COMMON_ERROR_CONTAINER_ID: jn,
  scrollToFirstErrorElement: To
}), Po = ["id"], jo = ["src"], $o = { class: "input-error__text" }, ko = /* @__PURE__ */ He({
  __name: "ErrorDisplay",
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const { COMMON_ERROR_CONTAINER_ID: t } = Io(), r = _n({
      containerId: `${t}-${Pn()}`
    });
    return (n, s) => (Z(), fe("div", {
      id: r.containerId,
      class: "input-error"
    }, [
      J("img", {
        class: "input-error__icon",
        src: wo(_o),
        alt: ""
      }, null, 8, jo),
      J("span", $o, rt(e.text), 1)
    ], 8, Po));
  }
}), Fo = /* @__PURE__ */ gt(ko, [["__scopeId", "data-v-70494e94"]]), Uo = ["checked", "value", "disabled"], No = /* @__PURE__ */ He({
  __name: "BaseCheckbox",
  props: /* @__PURE__ */ Tn({
    value: { type: [Boolean, String, Number] },
    trueValue: { type: [Boolean, String], default: !0 },
    falseValue: { type: [Boolean, String], default: !1 },
    disabled: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: [Boolean, String, Array], default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = In(e, "modelValue"), r = e, n = Q(() => t.value instanceof Array ? t.value.includes(r.value) : t.value === r.trueValue), s = Q(() => r.disabled ? ["base-checkbox--disabled"] : []), o = Q(() => n.value ? ["base-checkbox__input--checked"] : []), i = () => {
      if (!r.disabled)
        if (t.value instanceof Array) {
          const a = [...t.value];
          n.value ? a.splice(a.indexOf(r.value), 1) : a.push(r.value), t.value = a;
        } else
          t.value = n.value ? r.falseValue : r.trueValue;
    };
    return (a, u) => (Z(), fe("span", {
      class: It(["base-checkbox", s.value])
    }, [
      J("input", {
        type: "checkbox",
        class: It(["base-checkbox__input", o.value]),
        checked: n.value,
        value: a.value,
        disabled: a.disabled,
        onChange: i
      }, null, 42, Uo),
      u[0] || (u[0] = J("span", { class: "base-checkbox__checkmark" }, null, -1))
    ], 2));
  }
}), qo = /* @__PURE__ */ gt(No, [["__scopeId", "data-v-a6256959"]]), Do = { class: "opt-in" }, Lo = { class: "opt-in__checkbox" }, Mo = ["innerHTML"], Bo = /* @__PURE__ */ He({
  __name: "GetStartedOptIn",
  props: /* @__PURE__ */ Tn({
    label: { default: "" }
  }, {
    modelValue: { type: Boolean, required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = In(e, "modelValue");
    return (r, n) => (Z(), fe("label", Do, [
      J("span", Lo, [
        Ye(qo, {
          value: !0,
          modelValue: t.value,
          "onUpdate:modelValue": n[0] || (n[0] = (s) => t.value = s)
        }, null, 8, ["modelValue"])
      ]),
      J("span", {
        class: "opt-in__label",
        innerHTML: r.label
      }, null, 8, Mo)
    ]));
  }
}), Xt = /* @__PURE__ */ gt(Bo, [["__scopeId", "data-v-3a7d7ee2"]]);
var Ho = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function zo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $n = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(Ho, function() {
    function r() {
      return r = Object.assign || function(b) {
        for (var E = 1; E < arguments.length; E++) {
          var S = arguments[E];
          for (var y in S)
            Object.prototype.hasOwnProperty.call(S, y) && (b[y] = S[y]);
        }
        return b;
      }, r.apply(this, arguments);
    }
    function n(b, E) {
      if (b) {
        if (typeof b == "string") return s(b, E);
        var S = Object.prototype.toString.call(b).slice(8, -1);
        if (S === "Object" && b.constructor && (S = b.constructor.name), S === "Map" || S === "Set") return Array.from(b);
        if (S === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S)) return s(b, E);
      }
    }
    function s(b, E) {
      (E == null || E > b.length) && (E = b.length);
      for (var S = 0, y = new Array(E); S < E; S++) y[S] = b[S];
      return y;
    }
    function o(b, E) {
      var S = typeof Symbol < "u" && b[Symbol.iterator] || b["@@iterator"];
      if (S) return (S = S.call(b)).next.bind(S);
      if (Array.isArray(b) || (S = n(b)) || E) {
        S && (b = S);
        var y = 0;
        return function() {
          return y >= b.length ? {
            done: !0
          } : {
            done: !1,
            value: b[y++]
          };
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var i = "image-Tb9Ew8CXIwaY6R1kjMvI0uRR-2000x3000-jpg";
    function a(b) {
      var E = b.split("-"), S = E[1], y = E[2], F = E[3];
      if (!S || !y || !F)
        throw new Error("Malformed asset _ref '" + b + `'. Expected an id like "` + i + '".');
      var R = y.split("x"), k = R[0], z = R[1], Y = +k, K = +z, W = isFinite(Y) && isFinite(K);
      if (!W)
        throw new Error("Malformed asset _ref '" + b + `'. Expected an id like "` + i + '".');
      return {
        id: S,
        width: Y,
        height: K,
        format: F
      };
    }
    var u = function(E) {
      var S = E;
      return S ? typeof S._ref == "string" : !1;
    }, c = function(E) {
      var S = E;
      return S ? typeof S._id == "string" : !1;
    }, l = function(E) {
      var S = E;
      return S && S.asset ? typeof S.asset.url == "string" : !1;
    };
    function f(b) {
      if (!b)
        return null;
      var E;
      if (typeof b == "string" && g(b))
        E = {
          asset: {
            _ref: m(b)
          }
        };
      else if (typeof b == "string")
        E = {
          asset: {
            _ref: b
          }
        };
      else if (u(b))
        E = {
          asset: b
        };
      else if (c(b))
        E = {
          asset: {
            _ref: b._id || ""
          }
        };
      else if (l(b))
        E = {
          asset: {
            _ref: m(b.asset.url)
          }
        };
      else if (typeof b.asset == "object")
        E = r({}, b);
      else
        return null;
      var S = b;
      return S.crop && (E.crop = S.crop), S.hotspot && (E.hotspot = S.hotspot), p(E);
    }
    function g(b) {
      return /^https?:\/\//.test("" + b);
    }
    function m(b) {
      var E = b.split("/").slice(-1);
      return ("image-" + E[0]).replace(/\.([a-z]+)$/, "-$1");
    }
    function p(b) {
      if (b.crop && b.hotspot)
        return b;
      var E = r({}, b);
      return E.crop || (E.crop = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
      }), E.hotspot || (E.hotspot = {
        x: 0.5,
        y: 0.5,
        height: 1,
        width: 1
      }), E;
    }
    var h = [["width", "w"], ["height", "h"], ["format", "fm"], ["download", "dl"], ["blur", "blur"], ["sharpen", "sharp"], ["invert", "invert"], ["orientation", "or"], ["minHeight", "min-h"], ["maxHeight", "max-h"], ["minWidth", "min-w"], ["maxWidth", "max-w"], ["quality", "q"], ["fit", "fit"], ["crop", "crop"], ["saturation", "sat"], ["auto", "auto"], ["dpr", "dpr"], ["pad", "pad"], ["frame", "frame"]];
    function v(b) {
      var E = r({}, b || {}), S = E.source;
      delete E.source;
      var y = f(S);
      if (!y)
        throw new Error("Unable to resolve image URL from source (" + JSON.stringify(S) + ")");
      var F = y.asset._ref || y.asset._id || "", R = a(F), k = Math.round(y.crop.left * R.width), z = Math.round(y.crop.top * R.height), Y = {
        left: k,
        top: z,
        width: Math.round(R.width - y.crop.right * R.width - k),
        height: Math.round(R.height - y.crop.bottom * R.height - z)
      }, K = y.hotspot.height * R.height / 2, W = y.hotspot.width * R.width / 2, ke = y.hotspot.x * R.width, xe = y.hotspot.y * R.height, re = {
        left: ke - W,
        top: xe - K,
        right: ke + W,
        bottom: xe + K
      };
      return E.rect || E.focalPoint || E.ignoreImageParams || E.crop || (E = r({}, E, C({
        crop: Y,
        hotspot: re
      }, E))), x(r({}, E, {
        asset: R
      }));
    }
    function x(b) {
      var E = (b.baseUrl || "https://cdn.sanity.io").replace(/\/+$/, ""), S = b.vanityName ? "/" + b.vanityName : "", y = b.asset.id + "-" + b.asset.width + "x" + b.asset.height + "." + b.asset.format + S, F = E + "/images/" + b.projectId + "/" + b.dataset + "/" + y, R = [];
      if (b.rect) {
        var k = b.rect, z = k.left, Y = k.top, K = k.width, W = k.height, ke = z !== 0 || Y !== 0 || W !== b.asset.height || K !== b.asset.width;
        ke && R.push("rect=" + z + "," + Y + "," + K + "," + W);
      }
      b.bg && R.push("bg=" + b.bg), b.focalPoint && (R.push("fp-x=" + b.focalPoint.x), R.push("fp-y=" + b.focalPoint.y));
      var xe = [b.flipHorizontal && "h", b.flipVertical && "v"].filter(Boolean).join("");
      return xe && R.push("flip=" + xe), h.forEach(function(re) {
        var Ke = re[0], ie = re[1];
        typeof b[Ke] < "u" ? R.push(ie + "=" + encodeURIComponent(b[Ke])) : typeof b[ie] < "u" && R.push(ie + "=" + encodeURIComponent(b[ie]));
      }), R.length === 0 ? F : F + "?" + R.join("&");
    }
    function C(b, E) {
      var S, y = E.width, F = E.height;
      if (!(y && F))
        return {
          width: y,
          height: F,
          rect: b.crop
        };
      var R = b.crop, k = b.hotspot, z = y / F, Y = R.width / R.height;
      if (Y > z) {
        var K = Math.round(R.height), W = Math.round(K * z), ke = Math.max(0, Math.round(R.top)), xe = Math.round((k.right - k.left) / 2 + k.left), re = Math.max(0, Math.round(xe - W / 2));
        re < R.left ? re = R.left : re + W > R.left + R.width && (re = R.left + R.width - W), S = {
          left: re,
          top: ke,
          width: W,
          height: K
        };
      } else {
        var Ke = R.width, ie = Math.round(Ke / z), po = Math.max(0, Math.round(R.left)), mo = Math.round((k.bottom - k.top) / 2 + k.top), Qe = Math.max(0, Math.round(mo - ie / 2));
        Qe < R.top ? Qe = R.top : Qe + ie > R.top + R.height && (Qe = R.top + R.height - ie), S = {
          left: po,
          top: Qe,
          width: Ke,
          height: ie
        };
      }
      return {
        width: y,
        height: F,
        rect: S
      };
    }
    var A = ["clip", "crop", "fill", "fillmax", "max", "scale", "min"], I = ["top", "bottom", "left", "right", "center", "focalpoint", "entropy"], O = ["format"];
    function $(b) {
      return b && "config" in b ? typeof b.config == "function" : !1;
    }
    function B(b) {
      return b && "clientConfig" in b ? typeof b.clientConfig == "object" : !1;
    }
    function me(b) {
      for (var E = h, S = o(E), y; !(y = S()).done; ) {
        var F = y.value, R = F[0], k = F[1];
        if (b === R || b === k)
          return R;
      }
      return b;
    }
    function ye(b) {
      if ($(b)) {
        var E = b.config(), S = E.apiHost, y = E.projectId, F = E.dataset, R = S || "https://api.sanity.io";
        return new Qt(null, {
          baseUrl: R.replace(/^https:\/\/api\./, "https://cdn."),
          projectId: y,
          dataset: F
        });
      }
      if (B(b)) {
        var k = b.clientConfig, z = k.apiHost, Y = k.projectId, K = k.dataset, W = z || "https://api.sanity.io";
        return new Qt(null, {
          baseUrl: W.replace(/^https:\/\/api\./, "https://cdn."),
          projectId: Y,
          dataset: K
        });
      }
      return new Qt(null, b || {});
    }
    var Qt = /* @__PURE__ */ function() {
      function b(S, y) {
        this.options = void 0, this.options = S ? r({}, S.options || {}, y || {}) : r({}, y || {});
      }
      var E = b.prototype;
      return E.withOptions = function(y) {
        var F = y.baseUrl || this.options.baseUrl, R = {
          baseUrl: F
        };
        for (var k in y)
          if (y.hasOwnProperty(k)) {
            var z = me(k);
            R[z] = y[k];
          }
        return new b(this, r({
          baseUrl: F
        }, R));
      }, E.image = function(y) {
        return this.withOptions({
          source: y
        });
      }, E.dataset = function(y) {
        return this.withOptions({
          dataset: y
        });
      }, E.projectId = function(y) {
        return this.withOptions({
          projectId: y
        });
      }, E.bg = function(y) {
        return this.withOptions({
          bg: y
        });
      }, E.dpr = function(y) {
        return this.withOptions(y && y !== 1 ? {
          dpr: y
        } : {});
      }, E.width = function(y) {
        return this.withOptions({
          width: y
        });
      }, E.height = function(y) {
        return this.withOptions({
          height: y
        });
      }, E.focalPoint = function(y, F) {
        return this.withOptions({
          focalPoint: {
            x: y,
            y: F
          }
        });
      }, E.maxWidth = function(y) {
        return this.withOptions({
          maxWidth: y
        });
      }, E.minWidth = function(y) {
        return this.withOptions({
          minWidth: y
        });
      }, E.maxHeight = function(y) {
        return this.withOptions({
          maxHeight: y
        });
      }, E.minHeight = function(y) {
        return this.withOptions({
          minHeight: y
        });
      }, E.size = function(y, F) {
        return this.withOptions({
          width: y,
          height: F
        });
      }, E.blur = function(y) {
        return this.withOptions({
          blur: y
        });
      }, E.sharpen = function(y) {
        return this.withOptions({
          sharpen: y
        });
      }, E.rect = function(y, F, R, k) {
        return this.withOptions({
          rect: {
            left: y,
            top: F,
            width: R,
            height: k
          }
        });
      }, E.format = function(y) {
        return this.withOptions({
          format: y
        });
      }, E.invert = function(y) {
        return this.withOptions({
          invert: y
        });
      }, E.orientation = function(y) {
        return this.withOptions({
          orientation: y
        });
      }, E.quality = function(y) {
        return this.withOptions({
          quality: y
        });
      }, E.forceDownload = function(y) {
        return this.withOptions({
          download: y
        });
      }, E.flipHorizontal = function() {
        return this.withOptions({
          flipHorizontal: !0
        });
      }, E.flipVertical = function() {
        return this.withOptions({
          flipVertical: !0
        });
      }, E.ignoreImageParams = function() {
        return this.withOptions({
          ignoreImageParams: !0
        });
      }, E.fit = function(y) {
        if (A.indexOf(y) === -1)
          throw new Error('Invalid fit mode "' + y + '"');
        return this.withOptions({
          fit: y
        });
      }, E.crop = function(y) {
        if (I.indexOf(y) === -1)
          throw new Error('Invalid crop mode "' + y + '"');
        return this.withOptions({
          crop: y
        });
      }, E.saturation = function(y) {
        return this.withOptions({
          saturation: y
        });
      }, E.auto = function(y) {
        if (O.indexOf(y) === -1)
          throw new Error('Invalid auto mode "' + y + '"');
        return this.withOptions({
          auto: y
        });
      }, E.pad = function(y) {
        return this.withOptions({
          pad: y
        });
      }, E.vanityName = function(y) {
        return this.withOptions({
          vanityName: y
        });
      }, E.frame = function(y) {
        if (y !== 1)
          throw new Error('Invalid frame value "' + y + '"');
        return this.withOptions({
          frame: y
        });
      }, E.url = function() {
        return v(this.options);
      }, E.toString = function() {
        return this.url();
      }, b;
    }();
    return ye;
  });
})($n);
var Vo = $n.exports;
const Wo = /* @__PURE__ */ zo(Vo), kn = !(typeof navigator > "u") && navigator.product === "ReactNative", Fn = { timeout: kn ? 6e4 : 12e4 }, Jo = function(e) {
  const t = { ...Fn, ...typeof e == "string" ? { url: e } : e };
  if (t.timeout = Un(t.timeout), t.query) {
    const { url: r, searchParams: n } = function(s) {
      const o = s.indexOf("?");
      if (o === -1) return { url: s, searchParams: new URLSearchParams() };
      const i = s.slice(0, o), a = s.slice(o + 1);
      if (!kn) return { url: i, searchParams: new URLSearchParams(a) };
      if (typeof decodeURIComponent != "function") throw new Error("Broken `URLSearchParams` implementation, and `decodeURIComponent` is not defined");
      const u = new URLSearchParams();
      for (const c of a.split("&")) {
        const [l, f] = c.split("=");
        l && u.append(Mr(l), Mr(f || ""));
      }
      return { url: i, searchParams: u };
    }(t.url);
    for (const [s, o] of Object.entries(t.query)) {
      if (o !== void 0) if (Array.isArray(o)) for (const a of o) n.append(s, a);
      else n.append(s, o);
      const i = n.toString();
      i && (t.url = `${r}?${i}`);
    }
  }
  return t.method = t.body && !t.method ? "POST" : (t.method || "GET").toUpperCase(), t;
};
function Mr(e) {
  return decodeURIComponent(e.replace(/\+/g, " "));
}
function Un(e) {
  if (e === !1 || e === 0) return !1;
  if (e.connect || e.socket) return e;
  const t = Number(e);
  return isNaN(t) ? Un(Fn.timeout) : { connect: t, socket: t };
}
const Go = /^https?:\/\//i, Ko = function(e) {
  if (!Go.test(e.url)) throw new Error(`"${e.url}" is not a valid URL`);
};
function Nn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
const Qo = ["request", "response", "progress", "error", "abort"], Br = ["processOptions", "validateOptions", "interceptRequest", "finalizeOptions", "onRequest", "onResponse", "onError", "onReturn", "onHeaders"];
function qn(e, t) {
  const r = [], n = Br.reduce((o, i) => (o[i] = o[i] || [], o), { processOptions: [Jo], validateOptions: [Ko] });
  function s(o) {
    const i = Qo.reduce((m, p) => (m[p] = /* @__PURE__ */ function() {
      const h = /* @__PURE__ */ Object.create(null);
      let v = 0;
      return { publish: function(x) {
        for (const C in h) h[C](x);
      }, subscribe: function(x) {
        const C = v++;
        return h[C] = x, function() {
          delete h[C];
        };
      } };
    }(), m), {}), a = /* @__PURE__ */ ((m) => function(p, h, ...v) {
      const x = p === "onError";
      let C = h;
      for (let A = 0; A < m[p].length && (C = (0, m[p][A])(C, ...v), !x || C); A++) ;
      return C;
    })(n), u = a("processOptions", o);
    a("validateOptions", u);
    const c = { options: u, channels: i, applyMiddleware: a };
    let l;
    const f = i.request.subscribe((m) => {
      l = t(m, (p, h) => ((v, x, C) => {
        let A = v, I = x;
        if (!A) try {
          I = a("onResponse", x, C);
        } catch (O) {
          I = null, A = O;
        }
        A = A && a("onError", A, C), A ? i.error.publish(A) : I && i.response.publish(I);
      })(p, h, m));
    });
    i.abort.subscribe(() => {
      f(), l && l.abort();
    });
    const g = a("onReturn", i, c);
    return g === i && i.request.publish(c), g;
  }
  return s.use = function(o) {
    if (!o) throw new Error("Tried to add middleware that resolved to falsey value");
    if (typeof o == "function") throw new Error("Tried to add middleware that was a function. It probably expects you to pass options to it.");
    if (o.onReturn && n.onReturn.length > 0) throw new Error("Tried to add new middleware with `onReturn` handler, but another handler has already been registered for this event");
    return Br.forEach((i) => {
      o[i] && n[i].push(o[i]);
    }), r.push(o), s;
  }, s.clone = () => qn(r, t), e.forEach(s.use), s;
}
var Hr, zr, Xo = /* @__PURE__ */ Nn(function() {
  if (zr) return Hr;
  zr = 1;
  var e = function(t) {
    return t.replace(/^\s+|\s+$/g, "");
  };
  return Hr = function(t) {
    if (!t) return {};
    for (var r = {}, n = e(t).split(`
`), s = 0; s < n.length; s++) {
      var o = n[s], i = o.indexOf(":"), a = e(o.slice(0, i)).toLowerCase(), u = e(o.slice(i + 1));
      typeof r[a] > "u" ? r[a] = u : (c = r[a], Object.prototype.toString.call(c) === "[object Array]" ? r[a].push(u) : r[a] = [r[a], u]);
    }
    var c;
    return r;
  };
}()), ot, it, Ne, at, ae, ut, ct, An;
let ir = (An = class {
  constructor() {
    _(this, "onabort");
    _(this, "onerror");
    _(this, "onreadystatechange");
    _(this, "ontimeout");
    _(this, "readyState", 0);
    _(this, "response");
    _(this, "responseText", "");
    _(this, "responseType", "");
    _(this, "status");
    _(this, "statusText");
    _(this, "withCredentials");
    j(this, ot);
    j(this, it);
    j(this, Ne);
    j(this, at, {});
    j(this, ae);
    j(this, ut, {});
    j(this, ct);
  }
  open(t, r, n) {
    var s;
    P(this, ot, t), P(this, it, r), P(this, Ne, ""), this.readyState = 1, (s = this.onreadystatechange) == null || s.call(this), P(this, ae, void 0);
  }
  abort() {
    w(this, ae) && w(this, ae).abort();
  }
  getAllResponseHeaders() {
    return w(this, Ne);
  }
  setRequestHeader(t, r) {
    w(this, at)[t] = r;
  }
  setInit(t, r = !0) {
    P(this, ut, t), P(this, ct, r);
  }
  send(t) {
    const r = this.responseType !== "arraybuffer", n = { ...w(this, ut), method: w(this, ot), headers: w(this, at), body: t };
    typeof AbortController == "function" && w(this, ct) && (P(this, ae, new AbortController()), typeof EventTarget < "u" && w(this, ae).signal instanceof EventTarget && (n.signal = w(this, ae).signal)), typeof document < "u" && (n.credentials = this.withCredentials ? "include" : "omit"), fetch(w(this, it), n).then((s) => {
      var o;
      return s.headers.forEach((i, a) => {
        P(this, Ne, w(this, Ne) + `${a}: ${i}\r
`);
      }), this.status = s.status, this.statusText = s.statusText, this.readyState = 3, (o = this.onreadystatechange) == null || o.call(this), r ? s.text() : s.arrayBuffer();
    }).then((s) => {
      var o;
      typeof s == "string" ? this.responseText = s : this.response = s, this.readyState = 4, (o = this.onreadystatechange) == null || o.call(this);
    }).catch((s) => {
      var o, i;
      s.name !== "AbortError" ? (o = this.onerror) == null || o.call(this, s) : (i = this.onabort) == null || i.call(this);
    });
  }
}, ot = new WeakMap(), it = new WeakMap(), Ne = new WeakMap(), at = new WeakMap(), ae = new WeakMap(), ut = new WeakMap(), ct = new WeakMap(), An);
const ar = typeof XMLHttpRequest == "function" ? "xhr" : "fetch", Yo = ar === "xhr" ? XMLHttpRequest : ir, Zo = (e, t) => {
  const r = e.options, n = e.applyMiddleware("finalizeOptions", r), s = {}, o = e.applyMiddleware("interceptRequest", void 0, { adapter: ar, context: e });
  if (o) {
    const h = setTimeout(t, 0, null, o);
    return { abort: () => clearTimeout(h) };
  }
  let i = new Yo();
  i instanceof ir && typeof n.fetch == "object" && i.setInit(n.fetch, n.useAbortSignal ?? !0);
  const a = n.headers, u = n.timeout;
  let c = !1, l = !1, f = !1;
  if (i.onerror = (h) => {
    p(i instanceof ir ? h instanceof Error ? h : new Error(`Request error while attempting to reach is ${n.url}`, { cause: h }) : new Error(`Request error while attempting to reach is ${n.url}${h.lengthComputable ? `(${h.loaded} of ${h.total} bytes transferred)` : ""}`));
  }, i.ontimeout = (h) => {
    p(new Error(`Request timeout while attempting to reach ${n.url}${h.lengthComputable ? `(${h.loaded} of ${h.total} bytes transferred)` : ""}`));
  }, i.onabort = () => {
    m(!0), c = !0;
  }, i.onreadystatechange = () => {
    u && (m(), s.socket = setTimeout(() => g("ESOCKETTIMEDOUT"), u.socket)), !c && i.readyState === 4 && i.status !== 0 && function() {
      if (!(c || l || f)) {
        if (i.status === 0) return void p(new Error("Unknown XHR error"));
        m(), l = !0, t(null, { body: i.response || (i.responseType === "" || i.responseType === "text" ? i.responseText : ""), url: n.url, method: n.method, headers: Xo(i.getAllResponseHeaders()), statusCode: i.status, statusMessage: i.statusText });
      }
    }();
  }, i.open(n.method, n.url, !0), i.withCredentials = !!n.withCredentials, a && i.setRequestHeader) for (const h in a) a.hasOwnProperty(h) && i.setRequestHeader(h, a[h]);
  return n.rawBody && (i.responseType = "arraybuffer"), e.applyMiddleware("onRequest", { options: n, adapter: ar, request: i, context: e }), i.send(n.body || null), u && (s.connect = setTimeout(() => g("ETIMEDOUT"), u.connect)), { abort: function() {
    c = !0, i && i.abort();
  } };
  function g(h) {
    f = !0, i.abort();
    const v = new Error(h === "ESOCKETTIMEDOUT" ? `Socket timed out on request to ${n.url}` : `Connection timed out on request to ${n.url}`);
    v.code = h, e.channels.error.publish(v);
  }
  function m(h) {
    (h || c || i.readyState >= 2 && s.connect) && clearTimeout(s.connect), s.socket && clearTimeout(s.socket);
  }
  function p(h) {
    if (l) return;
    m(!0), l = !0, i = null;
    const v = h || new Error(`Network error while attempting to reach ${n.url}`);
    v.isNetworkError = !0, v.request = n, t(v);
  }
}, ei = (e = [], t = Zo) => qn(e, t);
var Vr, Wr, Jr, Gr, Kr, Yt = { exports: {} };
Kr || (Kr = 1, function(e, t) {
  t.formatArgs = function(n) {
    if (n[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + n[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors) return;
    const s = "color: " + this.color;
    n.splice(1, 0, s, "color: inherit");
    let o = 0, i = 0;
    n[0].replace(/%[a-zA-Z%]/g, (a) => {
      a !== "%%" && (o++, a === "%c" && (i = o));
    }), n.splice(i, 0, s);
  }, t.save = function(n) {
    try {
      n ? t.storage.setItem("debug", n) : t.storage.removeItem("debug");
    } catch {
    }
  }, t.load = function() {
    let n;
    try {
      n = t.storage.getItem("debug");
    } catch {
    }
    return !n && typeof process < "u" && "env" in process && (n = process.env.DEBUG), n;
  }, t.useColors = function() {
    if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return !0;
    if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
    let n;
    return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && (n = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(n[1], 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }, t.storage = function() {
    try {
      return localStorage;
    } catch {
    }
  }(), t.destroy = /* @__PURE__ */ (() => {
    let n = !1;
    return () => {
      n || (n = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  })(), t.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], t.log = console.debug || console.log || (() => {
  }), e.exports = (Gr ? Jr : (Gr = 1, Jr = function(n) {
    function s(a) {
      let u, c, l, f = null;
      function g(...m) {
        if (!g.enabled) return;
        const p = g, h = Number(/* @__PURE__ */ new Date()), v = h - (u || h);
        p.diff = v, p.prev = u, p.curr = h, u = h, m[0] = s.coerce(m[0]), typeof m[0] != "string" && m.unshift("%O");
        let x = 0;
        m[0] = m[0].replace(/%([a-zA-Z%])/g, (C, A) => {
          if (C === "%%") return "%";
          x++;
          const I = s.formatters[A];
          if (typeof I == "function") {
            const O = m[x];
            C = I.call(p, O), m.splice(x, 1), x--;
          }
          return C;
        }), s.formatArgs.call(p, m), (p.log || s.log).apply(p, m);
      }
      return g.namespace = a, g.useColors = s.useColors(), g.color = s.selectColor(a), g.extend = o, g.destroy = s.destroy, Object.defineProperty(g, "enabled", { enumerable: !0, configurable: !1, get: () => f !== null ? f : (c !== s.namespaces && (c = s.namespaces, l = s.enabled(a)), l), set: (m) => {
        f = m;
      } }), typeof s.init == "function" && s.init(g), g;
    }
    function o(a, u) {
      const c = s(this.namespace + (typeof u > "u" ? ":" : u) + a);
      return c.log = this.log, c;
    }
    function i(a, u) {
      let c = 0, l = 0, f = -1, g = 0;
      for (; c < a.length; ) if (l < u.length && (u[l] === a[c] || u[l] === "*")) u[l] === "*" ? (f = l, g = c, l++) : (c++, l++);
      else {
        if (f === -1) return !1;
        l = f + 1, g++, c = g;
      }
      for (; l < u.length && u[l] === "*"; ) l++;
      return l === u.length;
    }
    return s.debug = s, s.default = s, s.coerce = function(a) {
      return a instanceof Error ? a.stack || a.message : a;
    }, s.disable = function() {
      const a = [...s.names, ...s.skips.map((u) => "-" + u)].join(",");
      return s.enable(""), a;
    }, s.enable = function(a) {
      s.save(a), s.namespaces = a, s.names = [], s.skips = [];
      const u = (typeof a == "string" ? a : "").trim().replace(" ", ",").split(",").filter(Boolean);
      for (const c of u) c[0] === "-" ? s.skips.push(c.slice(1)) : s.names.push(c);
    }, s.enabled = function(a) {
      for (const u of s.skips) if (i(a, u)) return !1;
      for (const u of s.names) if (i(a, u)) return !0;
      return !1;
    }, s.humanize = function() {
      if (Wr) return Vr;
      Wr = 1;
      var a = 1e3, u = 60 * a, c = 60 * u, l = 24 * c, f = 7 * l;
      function g(m, p, h, v) {
        var x = p >= 1.5 * h;
        return Math.round(m / h) + " " + v + (x ? "s" : "");
      }
      return Vr = function(m, p) {
        p = p || {};
        var h, v, x = typeof m;
        if (x === "string" && m.length > 0) return function(C) {
          if (!((C = String(C)).length > 100)) {
            var A = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(C);
            if (A) {
              var I = parseFloat(A[1]);
              switch ((A[2] || "ms").toLowerCase()) {
                case "years":
                case "year":
                case "yrs":
                case "yr":
                case "y":
                  return 315576e5 * I;
                case "weeks":
                case "week":
                case "w":
                  return I * f;
                case "days":
                case "day":
                case "d":
                  return I * l;
                case "hours":
                case "hour":
                case "hrs":
                case "hr":
                case "h":
                  return I * c;
                case "minutes":
                case "minute":
                case "mins":
                case "min":
                case "m":
                  return I * u;
                case "seconds":
                case "second":
                case "secs":
                case "sec":
                case "s":
                  return I * a;
                case "milliseconds":
                case "millisecond":
                case "msecs":
                case "msec":
                case "ms":
                  return I;
                default:
                  return;
              }
            }
          }
        }(m);
        if (x === "number" && isFinite(m)) return p.long ? (h = m, (v = Math.abs(h)) >= l ? g(h, v, l, "day") : v >= c ? g(h, v, c, "hour") : v >= u ? g(h, v, u, "minute") : v >= a ? g(h, v, a, "second") : h + " ms") : function(C) {
          var A = Math.abs(C);
          return A >= l ? Math.round(C / l) + "d" : A >= c ? Math.round(C / c) + "h" : A >= u ? Math.round(C / u) + "m" : A >= a ? Math.round(C / a) + "s" : C + "ms";
        }(m);
        throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(m));
      };
    }(), s.destroy = function() {
      console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }, Object.keys(n).forEach((a) => {
      s[a] = n[a];
    }), s.names = [], s.skips = [], s.formatters = {}, s.selectColor = function(a) {
      let u = 0;
      for (let c = 0; c < a.length; c++) u = (u << 5) - u + a.charCodeAt(c), u |= 0;
      return s.colors[Math.abs(u) % s.colors.length];
    }, s.enable(s.load()), s;
  }))(t);
  const { formatters: r } = e.exports;
  r.j = function(n) {
    try {
      return JSON.stringify(n);
    } catch (s) {
      return "[UnexpectedJSONParseError]: " + s.message;
    }
  };
}(Yt, Yt.exports)), Yt.exports;
const ti = typeof Buffer > "u" ? () => !1 : (e) => Buffer.isBuffer(e);
function Qr(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ri(e) {
  if (Qr(e) === !1) return !1;
  const t = e.constructor;
  if (t === void 0) return !0;
  const r = t.prototype;
  return !(Qr(r) === !1 || r.hasOwnProperty("isPrototypeOf") === !1);
}
const ni = ["boolean", "string", "number"];
function si() {
  return { processOptions: (e) => {
    const t = e.body;
    return !t || typeof t.pipe == "function" || ti(t) || ni.indexOf(typeof t) === -1 && !Array.isArray(t) && !ri(t) ? e : Object.assign({}, e, { body: JSON.stringify(e.body), headers: Object.assign({}, e.headers, { "Content-Type": "application/json" }) });
  } };
}
function oi(e) {
  return { onResponse: (r) => {
    const n = r.headers["content-type"] || "", s = e && e.force || n.indexOf("application/json") !== -1;
    return r.body && n && s ? Object.assign({}, r, { body: t(r.body) }) : r;
  }, processOptions: (r) => Object.assign({}, r, { headers: Object.assign({ Accept: "application/json" }, r.headers) }) };
  function t(r) {
    try {
      return JSON.parse(r);
    } catch (n) {
      throw n.message = `Failed to parsed response body as JSON: ${n.message}`, n;
    }
  }
}
let Ze = {};
typeof globalThis < "u" ? Ze = globalThis : typeof window < "u" ? Ze = window : typeof global < "u" ? Ze = global : typeof self < "u" && (Ze = self);
var ii = Ze;
function ai(e = {}) {
  const t = e.implementation || ii.Observable;
  if (!t) throw new Error("`Observable` is not available in global scope, and no implementation was passed");
  return { onReturn: (r, n) => new t((s) => (r.error.subscribe((o) => s.error(o)), r.progress.subscribe((o) => s.next(Object.assign({ type: "progress" }, o))), r.response.subscribe((o) => {
    s.next(Object.assign({ type: "response" }, o)), s.complete();
  }), r.request.publish(n), () => r.abort.publish())) };
}
function ui() {
  return { onRequest: (e) => {
    if (e.adapter !== "xhr") return;
    const t = e.request, r = e.context;
    function n(s) {
      return (o) => {
        const i = o.lengthComputable ? o.loaded / o.total * 100 : -1;
        r.channels.progress.publish({ stage: s, percent: i, total: o.total, loaded: o.loaded, lengthComputable: o.lengthComputable });
      };
    }
    "upload" in t && "onprogress" in t.upload && (t.upload.onprogress = n("upload")), "onprogress" in t && (t.onprogress = n("download"));
  } };
}
var Dn = (e, t, r) => (r.method === "GET" || r.method === "HEAD") && (e.isNetworkError || !1);
function ci(e) {
  return 100 * Math.pow(2, e) + 100 * Math.random();
}
const br = (e = {}) => ((t) => {
  const r = t.maxRetries || 5, n = t.retryDelay || ci, s = t.shouldRetry;
  return { onError: (o, i) => {
    const a = i.options, u = a.maxRetries || r, c = a.retryDelay || n, l = a.shouldRetry || s, f = a.attemptNumber || 0;
    if ((g = a.body) !== null && typeof g == "object" && typeof g.pipe == "function" || !l(o, f, a) || f >= u) return o;
    var g;
    const m = Object.assign({}, i, { options: Object.assign({}, a, { attemptNumber: f + 1 }) });
    return setTimeout(() => i.channels.request.publish(m), c(f)), null;
  } };
})({ shouldRetry: Dn, ...e });
br.shouldRetry = Dn;
var ur = function(e, t) {
  return ur = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (r[s] = n[s]);
  }, ur(e, t);
};
function pe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  ur(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
function li(e, t, r, n) {
  function s(o) {
    return o instanceof r ? o : new r(function(i) {
      i(o);
    });
  }
  return new (r || (r = Promise))(function(o, i) {
    function a(l) {
      try {
        c(n.next(l));
      } catch (f) {
        i(f);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        i(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : s(l.value).then(a, u);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
function Ln(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, s, o, i = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return i.next = a(0), i.throw = a(1), i.return = a(2), typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function a(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, c[0] && (r = 0)), r; ) try {
      if (n = 1, s && (o = c[0] & 2 ? s.return : c[0] ? s.throw || ((o = s.return) && o.call(s), 0) : s.next) && !(o = o.call(s, c[1])).done) return o;
      switch (s = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, s = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = c;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(c);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (l) {
      c = [6, l], s = 0;
    } finally {
      n = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function Be(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function de(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), s, o = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(s = n.next()).done; ) o.push(s.value);
  } catch (a) {
    i = { error: a };
  } finally {
    try {
      s && !s.done && (r = n.return) && r.call(n);
    } finally {
      if (i) throw i.error;
    }
  }
  return o;
}
function he(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, s = t.length, o; n < s; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function Fe(e) {
  return this instanceof Fe ? (this.v = e, this) : new Fe(e);
}
function fi(e, t, r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = r.apply(e, t || []), s, o = [];
  return s = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), a("next"), a("throw"), a("return", i), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function i(m) {
    return function(p) {
      return Promise.resolve(p).then(m, f);
    };
  }
  function a(m, p) {
    n[m] && (s[m] = function(h) {
      return new Promise(function(v, x) {
        o.push([m, h, v, x]) > 1 || u(m, h);
      });
    }, p && (s[m] = p(s[m])));
  }
  function u(m, p) {
    try {
      c(n[m](p));
    } catch (h) {
      g(o[0][3], h);
    }
  }
  function c(m) {
    m.value instanceof Fe ? Promise.resolve(m.value.v).then(l, f) : g(o[0][2], m);
  }
  function l(m) {
    u("next", m);
  }
  function f(m) {
    u("throw", m);
  }
  function g(m, p) {
    m(p), o.shift(), o.length && u(o[0][0], o[0][1]);
  }
}
function di(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], r;
  return t ? t.call(e) : (e = typeof Be == "function" ? Be(e) : e[Symbol.iterator](), r = {}, n("next"), n("throw"), n("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r);
  function n(o) {
    r[o] = e[o] && function(i) {
      return new Promise(function(a, u) {
        i = e[o](i), s(a, u, i.done, i.value);
      });
    };
  }
  function s(o, i, a, u) {
    Promise.resolve(u).then(function(c) {
      o({ value: c, done: a });
    }, i);
  }
}
function U(e) {
  return typeof e == "function";
}
function gr(e) {
  var t = function(n) {
    Error.call(n), n.stack = new Error().stack;
  }, r = e(t);
  return r.prototype = Object.create(Error.prototype), r.prototype.constructor = r, r;
}
var Zt = gr(function(e) {
  return function(r) {
    e(this), this.message = r ? r.length + ` errors occurred during unsubscription:
` + r.map(function(n, s) {
      return s + 1 + ") " + n.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = r;
  };
});
function jt(e, t) {
  if (e) {
    var r = e.indexOf(t);
    0 <= r && e.splice(r, 1);
  }
}
var wt = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, r, n, s, o;
    if (!this.closed) {
      this.closed = !0;
      var i = this._parentage;
      if (i)
        if (this._parentage = null, Array.isArray(i))
          try {
            for (var a = Be(i), u = a.next(); !u.done; u = a.next()) {
              var c = u.value;
              c.remove(this);
            }
          } catch (h) {
            t = { error: h };
          } finally {
            try {
              u && !u.done && (r = a.return) && r.call(a);
            } finally {
              if (t) throw t.error;
            }
          }
        else
          i.remove(this);
      var l = this.initialTeardown;
      if (U(l))
        try {
          l();
        } catch (h) {
          o = h instanceof Zt ? h.errors : [h];
        }
      var f = this._finalizers;
      if (f) {
        this._finalizers = null;
        try {
          for (var g = Be(f), m = g.next(); !m.done; m = g.next()) {
            var p = m.value;
            try {
              Xr(p);
            } catch (h) {
              o = o ?? [], h instanceof Zt ? o = he(he([], de(o)), de(h.errors)) : o.push(h);
            }
          }
        } catch (h) {
          n = { error: h };
        } finally {
          try {
            m && !m.done && (s = g.return) && s.call(g);
          } finally {
            if (n) throw n.error;
          }
        }
      }
      if (o)
        throw new Zt(o);
    }
  }, e.prototype.add = function(t) {
    var r;
    if (t && t !== this)
      if (this.closed)
        Xr(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (r = this._finalizers) !== null && r !== void 0 ? r : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var r = this._parentage;
    return r === t || Array.isArray(r) && r.includes(t);
  }, e.prototype._addParent = function(t) {
    var r = this._parentage;
    this._parentage = Array.isArray(r) ? (r.push(t), r) : r ? [r, t] : t;
  }, e.prototype._removeParent = function(t) {
    var r = this._parentage;
    r === t ? this._parentage = null : Array.isArray(r) && jt(r, t);
  }, e.prototype.remove = function(t) {
    var r = this._finalizers;
    r && jt(r, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}(), Mn = wt.EMPTY;
function Bn(e) {
  return e instanceof wt || e && "closed" in e && U(e.remove) && U(e.add) && U(e.unsubscribe);
}
function Xr(e) {
  U(e) ? e() : e.unsubscribe();
}
var hi = {
  Promise: void 0
}, pi = {
  setTimeout: function(e, t) {
    for (var r = [], n = 2; n < arguments.length; n++)
      r[n - 2] = arguments[n];
    return setTimeout.apply(void 0, he([e, t], de(r)));
  },
  clearTimeout: function(e) {
    return clearTimeout(e);
  },
  delegate: void 0
};
function Hn(e) {
  pi.setTimeout(function() {
    throw e;
  });
}
function Yr() {
}
function At(e) {
  e();
}
var wr = function(e) {
  pe(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n.isStopped = !1, r ? (n.destination = r, Bn(r) && r.add(n)) : n.destination = bi, n;
  }
  return t.create = function(r, n, s) {
    return new nt(r, n, s);
  }, t.prototype.next = function(r) {
    this.isStopped || this._next(r);
  }, t.prototype.error = function(r) {
    this.isStopped || (this.isStopped = !0, this._error(r));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(r) {
    this.destination.next(r);
  }, t.prototype._error = function(r) {
    try {
      this.destination.error(r);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(wt), mi = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var r = this.partialObserver;
    if (r.next)
      try {
        r.next(t);
      } catch (n) {
        Ot(n);
      }
  }, e.prototype.error = function(t) {
    var r = this.partialObserver;
    if (r.error)
      try {
        r.error(t);
      } catch (n) {
        Ot(n);
      }
    else
      Ot(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (r) {
        Ot(r);
      }
  }, e;
}(), nt = function(e) {
  pe(t, e);
  function t(r, n, s) {
    var o = e.call(this) || this, i;
    return U(r) || !r ? i = {
      next: r ?? void 0,
      error: n ?? void 0,
      complete: s ?? void 0
    } : i = r, o.destination = new mi(i), o;
  }
  return t;
}(wr);
function Ot(e) {
  Hn(e);
}
function yi(e) {
  throw e;
}
var bi = {
  closed: !0,
  next: Yr,
  error: yi,
  complete: Yr
}, vr = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Mt(e) {
  return e;
}
function gi() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return zn(e);
}
function zn(e) {
  return e.length === 0 ? Mt : e.length === 1 ? e[0] : function(r) {
    return e.reduce(function(n, s) {
      return s(n);
    }, r);
  };
}
var N = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var r = new e();
    return r.source = this, r.operator = t, r;
  }, e.prototype.subscribe = function(t, r, n) {
    var s = this, o = vi(t) ? t : new nt(t, r, n);
    return At(function() {
      var i = s, a = i.operator, u = i.source;
      o.add(a ? a.call(o, u) : u ? s._subscribe(o) : s._trySubscribe(o));
    }), o;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (r) {
      t.error(r);
    }
  }, e.prototype.forEach = function(t, r) {
    var n = this;
    return r = Zr(r), new r(function(s, o) {
      var i = new nt({
        next: function(a) {
          try {
            t(a);
          } catch (u) {
            o(u), i.unsubscribe();
          }
        },
        error: o,
        complete: s
      });
      n.subscribe(i);
    });
  }, e.prototype._subscribe = function(t) {
    var r;
    return (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(t);
  }, e.prototype[vr] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    return zn(t)(this);
  }, e.prototype.toPromise = function(t) {
    var r = this;
    return t = Zr(t), new t(function(n, s) {
      var o;
      r.subscribe(function(i) {
        return o = i;
      }, function(i) {
        return s(i);
      }, function() {
        return n(o);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function Zr(e) {
  var t;
  return (t = e ?? hi.Promise) !== null && t !== void 0 ? t : Promise;
}
function wi(e) {
  return e && U(e.next) && U(e.error) && U(e.complete);
}
function vi(e) {
  return e && e instanceof wr || wi(e) && Bn(e);
}
function Ei(e) {
  return U(e == null ? void 0 : e.lift);
}
function se(e) {
  return function(t) {
    if (Ei(t))
      return t.lift(function(r) {
        try {
          return e(r, this);
        } catch (n) {
          this.error(n);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function Ce(e, t, r, n, s) {
  return new Si(e, t, r, n, s);
}
var Si = function(e) {
  pe(t, e);
  function t(r, n, s, o, i, a) {
    var u = e.call(this, r) || this;
    return u.onFinalize = i, u.shouldUnsubscribe = a, u._next = n ? function(c) {
      try {
        n(c);
      } catch (l) {
        r.error(l);
      }
    } : e.prototype._next, u._error = o ? function(c) {
      try {
        o(c);
      } catch (l) {
        r.error(l);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, u._complete = s ? function() {
      try {
        s();
      } catch (c) {
        r.error(c);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, u;
  }
  return t.prototype.unsubscribe = function() {
    var r;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var n = this.closed;
      e.prototype.unsubscribe.call(this), !n && ((r = this.onFinalize) === null || r === void 0 || r.call(this));
    }
  }, t;
}(wr), Ci = gr(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), Er = function(e) {
  pe(t, e);
  function t() {
    var r = e.call(this) || this;
    return r.closed = !1, r.currentObservers = null, r.observers = [], r.isStopped = !1, r.hasError = !1, r.thrownError = null, r;
  }
  return t.prototype.lift = function(r) {
    var n = new en(this, this);
    return n.operator = r, n;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new Ci();
  }, t.prototype.next = function(r) {
    var n = this;
    At(function() {
      var s, o;
      if (n._throwIfClosed(), !n.isStopped) {
        n.currentObservers || (n.currentObservers = Array.from(n.observers));
        try {
          for (var i = Be(n.currentObservers), a = i.next(); !a.done; a = i.next()) {
            var u = a.value;
            u.next(r);
          }
        } catch (c) {
          s = { error: c };
        } finally {
          try {
            a && !a.done && (o = i.return) && o.call(i);
          } finally {
            if (s) throw s.error;
          }
        }
      }
    });
  }, t.prototype.error = function(r) {
    var n = this;
    At(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.hasError = n.isStopped = !0, n.thrownError = r;
        for (var s = n.observers; s.length; )
          s.shift().error(r);
      }
    });
  }, t.prototype.complete = function() {
    var r = this;
    At(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.isStopped = !0;
        for (var n = r.observers; n.length; )
          n.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var r;
      return ((r = this.observers) === null || r === void 0 ? void 0 : r.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(r) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, r);
  }, t.prototype._subscribe = function(r) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(r), this._innerSubscribe(r);
  }, t.prototype._innerSubscribe = function(r) {
    var n = this, s = this, o = s.hasError, i = s.isStopped, a = s.observers;
    return o || i ? Mn : (this.currentObservers = null, a.push(r), new wt(function() {
      n.currentObservers = null, jt(a, r);
    }));
  }, t.prototype._checkFinalizedStatuses = function(r) {
    var n = this, s = n.hasError, o = n.thrownError, i = n.isStopped;
    s ? r.error(o) : i && r.complete();
  }, t.prototype.asObservable = function() {
    var r = new N();
    return r.source = this, r;
  }, t.create = function(r, n) {
    return new en(r, n);
  }, t;
}(N), en = function(e) {
  pe(t, e);
  function t(r, n) {
    var s = e.call(this) || this;
    return s.destination = r, s.source = n, s;
  }
  return t.prototype.next = function(r) {
    var n, s;
    (s = (n = this.destination) === null || n === void 0 ? void 0 : n.next) === null || s === void 0 || s.call(n, r);
  }, t.prototype.error = function(r) {
    var n, s;
    (s = (n = this.destination) === null || n === void 0 ? void 0 : n.error) === null || s === void 0 || s.call(n, r);
  }, t.prototype.complete = function() {
    var r, n;
    (n = (r = this.destination) === null || r === void 0 ? void 0 : r.complete) === null || n === void 0 || n.call(r);
  }, t.prototype._subscribe = function(r) {
    var n, s;
    return (s = (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(r)) !== null && s !== void 0 ? s : Mn;
  }, t;
}(Er), Sr = {
  now: function() {
    return (Sr.delegate || Date).now();
  },
  delegate: void 0
}, xi = function(e) {
  pe(t, e);
  function t(r, n, s) {
    r === void 0 && (r = 1 / 0), n === void 0 && (n = 1 / 0), s === void 0 && (s = Sr);
    var o = e.call(this) || this;
    return o._bufferSize = r, o._windowTime = n, o._timestampProvider = s, o._buffer = [], o._infiniteTimeWindow = !0, o._infiniteTimeWindow = n === 1 / 0, o._bufferSize = Math.max(1, r), o._windowTime = Math.max(1, n), o;
  }
  return t.prototype.next = function(r) {
    var n = this, s = n.isStopped, o = n._buffer, i = n._infiniteTimeWindow, a = n._timestampProvider, u = n._windowTime;
    s || (o.push(r), !i && o.push(a.now() + u)), this._trimBuffer(), e.prototype.next.call(this, r);
  }, t.prototype._subscribe = function(r) {
    this._throwIfClosed(), this._trimBuffer();
    for (var n = this._innerSubscribe(r), s = this, o = s._infiniteTimeWindow, i = s._buffer, a = i.slice(), u = 0; u < a.length && !r.closed; u += o ? 1 : 2)
      r.next(a[u]);
    return this._checkFinalizedStatuses(r), n;
  }, t.prototype._trimBuffer = function() {
    var r = this, n = r._bufferSize, s = r._timestampProvider, o = r._buffer, i = r._infiniteTimeWindow, a = (i ? 1 : 2) * n;
    if (n < 1 / 0 && a < o.length && o.splice(0, o.length - a), !i) {
      for (var u = s.now(), c = 0, l = 1; l < o.length && o[l] <= u; l += 2)
        c = l;
      c && o.splice(0, c + 1);
    }
  }, t;
}(Er), Oi = function(e) {
  pe(t, e);
  function t(r, n) {
    return e.call(this) || this;
  }
  return t.prototype.schedule = function(r, n) {
    return this;
  }, t;
}(wt), tn = {
  setInterval: function(e, t) {
    for (var r = [], n = 2; n < arguments.length; n++)
      r[n - 2] = arguments[n];
    return setInterval.apply(void 0, he([e, t], de(r)));
  },
  clearInterval: function(e) {
    return clearInterval(e);
  },
  delegate: void 0
}, Ai = function(e) {
  pe(t, e);
  function t(r, n) {
    var s = e.call(this, r, n) || this;
    return s.scheduler = r, s.work = n, s.pending = !1, s;
  }
  return t.prototype.schedule = function(r, n) {
    var s;
    if (n === void 0 && (n = 0), this.closed)
      return this;
    this.state = r;
    var o = this.id, i = this.scheduler;
    return o != null && (this.id = this.recycleAsyncId(i, o, n)), this.pending = !0, this.delay = n, this.id = (s = this.id) !== null && s !== void 0 ? s : this.requestAsyncId(i, this.id, n), this;
  }, t.prototype.requestAsyncId = function(r, n, s) {
    return s === void 0 && (s = 0), tn.setInterval(r.flush.bind(r, this), s);
  }, t.prototype.recycleAsyncId = function(r, n, s) {
    if (s === void 0 && (s = 0), s != null && this.delay === s && this.pending === !1)
      return n;
    n != null && tn.clearInterval(n);
  }, t.prototype.execute = function(r, n) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var s = this._execute(r, n);
    if (s)
      return s;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, t.prototype._execute = function(r, n) {
    var s = !1, o;
    try {
      this.work(r);
    } catch (i) {
      s = !0, o = i || new Error("Scheduled action threw falsy error");
    }
    if (s)
      return this.unsubscribe(), o;
  }, t.prototype.unsubscribe = function() {
    if (!this.closed) {
      var r = this, n = r.id, s = r.scheduler, o = s.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, jt(o, this), n != null && (this.id = this.recycleAsyncId(s, n, null)), this.delay = null, e.prototype.unsubscribe.call(this);
    }
  }, t;
}(Oi), rn = function() {
  function e(t, r) {
    r === void 0 && (r = e.now), this.schedulerActionCtor = t, this.now = r;
  }
  return e.prototype.schedule = function(t, r, n) {
    return r === void 0 && (r = 0), new this.schedulerActionCtor(this, t).schedule(n, r);
  }, e.now = Sr.now, e;
}(), Ri = function(e) {
  pe(t, e);
  function t(r, n) {
    n === void 0 && (n = rn.now);
    var s = e.call(this, r, n) || this;
    return s.actions = [], s._active = !1, s;
  }
  return t.prototype.flush = function(r) {
    var n = this.actions;
    if (this._active) {
      n.push(r);
      return;
    }
    var s;
    this._active = !0;
    do
      if (s = r.execute(r.state, r.delay))
        break;
    while (r = n.shift());
    if (this._active = !1, s) {
      for (; r = n.shift(); )
        r.unsubscribe();
      throw s;
    }
  }, t;
}(rn), _i = new Ri(Ai), Ti = _i, Vn = new N(function(e) {
  return e.complete();
});
function Ii(e) {
  return e && U(e.schedule);
}
function Cr(e) {
  return e[e.length - 1];
}
function Pi(e) {
  return U(Cr(e)) ? e.pop() : void 0;
}
function xr(e) {
  return Ii(Cr(e)) ? e.pop() : void 0;
}
function ji(e, t) {
  return typeof Cr(e) == "number" ? e.pop() : t;
}
var Wn = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function Jn(e) {
  return U(e == null ? void 0 : e.then);
}
function Gn(e) {
  return U(e[vr]);
}
function Kn(e) {
  return Symbol.asyncIterator && U(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function Qn(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function $i() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var Xn = $i();
function Yn(e) {
  return U(e == null ? void 0 : e[Xn]);
}
function Zn(e) {
  return fi(this, arguments, function() {
    var r, n, s, o;
    return Ln(this, function(i) {
      switch (i.label) {
        case 0:
          r = e.getReader(), i.label = 1;
        case 1:
          i.trys.push([1, , 9, 10]), i.label = 2;
        case 2:
          return [4, Fe(r.read())];
        case 3:
          return n = i.sent(), s = n.value, o = n.done, o ? [4, Fe(void 0)] : [3, 5];
        case 4:
          return [2, i.sent()];
        case 5:
          return [4, Fe(s)];
        case 6:
          return [4, i.sent()];
        case 7:
          return i.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return r.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function es(e) {
  return U(e == null ? void 0 : e.getReader);
}
function oe(e) {
  if (e instanceof N)
    return e;
  if (e != null) {
    if (Gn(e))
      return ki(e);
    if (Wn(e))
      return Fi(e);
    if (Jn(e))
      return Ui(e);
    if (Kn(e))
      return ts(e);
    if (Yn(e))
      return Ni(e);
    if (es(e))
      return qi(e);
  }
  throw Qn(e);
}
function ki(e) {
  return new N(function(t) {
    var r = e[vr]();
    if (U(r.subscribe))
      return r.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function Fi(e) {
  return new N(function(t) {
    for (var r = 0; r < e.length && !t.closed; r++)
      t.next(e[r]);
    t.complete();
  });
}
function Ui(e) {
  return new N(function(t) {
    e.then(function(r) {
      t.closed || (t.next(r), t.complete());
    }, function(r) {
      return t.error(r);
    }).then(null, Hn);
  });
}
function Ni(e) {
  return new N(function(t) {
    var r, n;
    try {
      for (var s = Be(e), o = s.next(); !o.done; o = s.next()) {
        var i = o.value;
        if (t.next(i), t.closed)
          return;
      }
    } catch (a) {
      r = { error: a };
    } finally {
      try {
        o && !o.done && (n = s.return) && n.call(s);
      } finally {
        if (r) throw r.error;
      }
    }
    t.complete();
  });
}
function ts(e) {
  return new N(function(t) {
    Di(e, t).catch(function(r) {
      return t.error(r);
    });
  });
}
function qi(e) {
  return ts(Zn(e));
}
function Di(e, t) {
  var r, n, s, o;
  return li(this, void 0, void 0, function() {
    var i, a;
    return Ln(this, function(u) {
      switch (u.label) {
        case 0:
          u.trys.push([0, 5, 6, 11]), r = di(e), u.label = 1;
        case 1:
          return [4, r.next()];
        case 2:
          if (n = u.sent(), !!n.done) return [3, 4];
          if (i = n.value, t.next(i), t.closed)
            return [2];
          u.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return a = u.sent(), s = { error: a }, [3, 11];
        case 6:
          return u.trys.push([6, , 9, 10]), n && !n.done && (o = r.return) ? [4, o.call(r)] : [3, 8];
        case 7:
          u.sent(), u.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (s) throw s.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function Te(e, t, r, n, s) {
  n === void 0 && (n = 0), s === void 0 && (s = !1);
  var o = t.schedule(function() {
    r(), s ? e.add(this.schedule(null, n)) : this.unsubscribe();
  }, n);
  if (e.add(o), !s)
    return o;
}
function rs(e, t) {
  return t === void 0 && (t = 0), se(function(r, n) {
    r.subscribe(Ce(n, function(s) {
      return Te(n, e, function() {
        return n.next(s);
      }, t);
    }, function() {
      return Te(n, e, function() {
        return n.complete();
      }, t);
    }, function(s) {
      return Te(n, e, function() {
        return n.error(s);
      }, t);
    }));
  });
}
function ns(e, t) {
  return t === void 0 && (t = 0), se(function(r, n) {
    n.add(e.schedule(function() {
      return r.subscribe(n);
    }, t));
  });
}
function Li(e, t) {
  return oe(e).pipe(ns(t), rs(t));
}
function Mi(e, t) {
  return oe(e).pipe(ns(t), rs(t));
}
function Bi(e, t) {
  return new N(function(r) {
    var n = 0;
    return t.schedule(function() {
      n === e.length ? r.complete() : (r.next(e[n++]), r.closed || this.schedule());
    });
  });
}
function Hi(e, t) {
  return new N(function(r) {
    var n;
    return Te(r, t, function() {
      n = e[Xn](), Te(r, t, function() {
        var s, o, i;
        try {
          s = n.next(), o = s.value, i = s.done;
        } catch (a) {
          r.error(a);
          return;
        }
        i ? r.complete() : r.next(o);
      }, 0, !0);
    }), function() {
      return U(n == null ? void 0 : n.return) && n.return();
    };
  });
}
function ss(e, t) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new N(function(r) {
    Te(r, t, function() {
      var n = e[Symbol.asyncIterator]();
      Te(r, t, function() {
        n.next().then(function(s) {
          s.done ? r.complete() : r.next(s.value);
        });
      }, 0, !0);
    });
  });
}
function zi(e, t) {
  return ss(Zn(e), t);
}
function Vi(e, t) {
  if (e != null) {
    if (Gn(e))
      return Li(e, t);
    if (Wn(e))
      return Bi(e, t);
    if (Jn(e))
      return Mi(e, t);
    if (Kn(e))
      return ss(e, t);
    if (Yn(e))
      return Hi(e, t);
    if (es(e))
      return zi(e, t);
  }
  throw Qn(e);
}
function vt(e, t) {
  return t ? Vi(e, t) : oe(e);
}
function Bt() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = xr(e);
  return vt(e, r);
}
function os(e, t) {
  var r = U(e) ? e : function() {
    return e;
  }, n = function(s) {
    return s.error(r());
  };
  return new N(n);
}
function Wi(e) {
  return !!e && (e instanceof N || U(e.lift) && U(e.subscribe));
}
var Ji = gr(function(e) {
  return function() {
    e(this), this.name = "EmptyError", this.message = "no elements in sequence";
  };
});
function M(e, t) {
  return new Promise(function(r, n) {
    var s = !1, o;
    e.subscribe({
      next: function(i) {
        o = i, s = !0;
      },
      error: n,
      complete: function() {
        s ? r(o) : n(new Ji());
      }
    });
  });
}
function Gi(e) {
  return e instanceof Date && !isNaN(e);
}
function V(e, t) {
  return se(function(r, n) {
    var s = 0;
    r.subscribe(Ce(n, function(o) {
      n.next(e.call(t, o, s++));
    }));
  });
}
var Ki = Array.isArray;
function Qi(e, t) {
  return Ki(t) ? e.apply(void 0, he([], de(t))) : e(t);
}
function Xi(e) {
  return V(function(t) {
    return Qi(e, t);
  });
}
function Yi(e, t, r) {
  return r === void 0 && (r = Mt), function(n) {
    nn(t, function() {
      for (var s = e.length, o = new Array(s), i = s, a = s, u = function(l) {
        nn(t, function() {
          var f = vt(e[l], t), g = !1;
          f.subscribe(Ce(n, function(m) {
            o[l] = m, g || (g = !0, a--), a || n.next(r(o.slice()));
          }, function() {
            --i || n.complete();
          }));
        }, n);
      }, c = 0; c < s; c++)
        u(c);
    });
  };
}
function nn(e, t, r) {
  t();
}
function Zi(e, t, r, n, s, o, i, a) {
  var u = [], c = 0, l = 0, f = !1, g = function() {
    f && !u.length && !c && t.complete();
  }, m = function(h) {
    return c < n ? p(h) : u.push(h);
  }, p = function(h) {
    c++;
    var v = !1;
    oe(r(h, l++)).subscribe(Ce(t, function(x) {
      t.next(x);
    }, function() {
      v = !0;
    }, void 0, function() {
      if (v)
        try {
          c--;
          for (var x = function() {
            var C = u.shift();
            i || p(C);
          }; u.length && c < n; )
            x();
          g();
        } catch (C) {
          t.error(C);
        }
    }));
  };
  return e.subscribe(Ce(t, m, function() {
    f = !0, g();
  })), function() {
  };
}
function Et(e, t, r) {
  return r === void 0 && (r = 1 / 0), U(t) ? Et(function(n, s) {
    return V(function(o, i) {
      return t(n, o, s, i);
    })(oe(e(n, s)));
  }, r) : (typeof t == "number" && (r = t), se(function(n, s) {
    return Zi(n, s, e, r);
  }));
}
function is(e) {
  return e === void 0 && (e = 1 / 0), Et(Mt, e);
}
function ea() {
  return is(1);
}
function as() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return ea()(vt(e, xr(e)));
}
function us(e) {
  return new N(function(t) {
    oe(e()).subscribe(t);
  });
}
function ta(e, t, r) {
  return r === void 0 && (r = Ti), new N(function(n) {
    var s = Gi(e) ? 1e3 - r.now() : e;
    s < 0 && (s = 0);
    var o = 0;
    return r.schedule(function() {
      n.closed || (n.next(o++), n.complete());
    }, s);
  });
}
function ra() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = xr(e), n = ji(e, 1 / 0), s = e;
  return s.length ? s.length === 1 ? oe(s[0]) : is(n)(vt(s, r)) : Vn;
}
var na = Array.isArray;
function sa(e) {
  return e.length === 1 && na(e[0]) ? e[0] : e;
}
function ze(e, t) {
  return se(function(r, n) {
    var s = 0;
    r.subscribe(Ce(n, function(o) {
      return e.call(t, o, s++) && n.next(o);
    }));
  });
}
function Or(e) {
  return se(function(t, r) {
    var n = null, s = !1, o;
    n = t.subscribe(Ce(r, void 0, void 0, function(i) {
      o = oe(e(i, Or(e)(t))), n ? (n.unsubscribe(), n = null, o.subscribe(r)) : s = !0;
    })), s && (n.unsubscribe(), n = null, o.subscribe(r));
  });
}
function cs() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = Pi(e);
  return r ? gi(cs.apply(void 0, he([], de(e))), Xi(r)) : se(function(n, s) {
    Yi(he([n], de(sa(e))))(s);
  });
}
function oa() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return cs.apply(void 0, he([], de(e)));
}
function ls(e) {
  return se(function(t, r) {
    try {
      t.subscribe(r);
    } finally {
      r.add(e);
    }
  });
}
function fs(e) {
  e === void 0 && (e = {});
  var t = e.connector, r = t === void 0 ? function() {
    return new Er();
  } : t, n = e.resetOnError, s = n === void 0 ? !0 : n, o = e.resetOnComplete, i = o === void 0 ? !0 : o, a = e.resetOnRefCountZero, u = a === void 0 ? !0 : a;
  return function(c) {
    var l, f, g, m = 0, p = !1, h = !1, v = function() {
      f == null || f.unsubscribe(), f = void 0;
    }, x = function() {
      v(), l = g = void 0, p = h = !1;
    }, C = function() {
      var A = l;
      x(), A == null || A.unsubscribe();
    };
    return se(function(A, I) {
      m++, !h && !p && v();
      var O = g = g ?? r();
      I.add(function() {
        m--, m === 0 && !h && !p && (f = er(C, u));
      }), O.subscribe(I), !l && m > 0 && (l = new nt({
        next: function($) {
          return O.next($);
        },
        error: function($) {
          h = !0, v(), f = er(x, s, $), O.error($);
        },
        complete: function() {
          p = !0, v(), f = er(x, i), O.complete();
        }
      }), oe(A).subscribe(l));
    })(c);
  };
}
function er(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  if (t === !0) {
    e();
    return;
  }
  if (t !== !1) {
    var s = new nt({
      next: function() {
        s.unsubscribe(), e();
      }
    });
    return oe(t.apply(void 0, he([], de(r)))).subscribe(s);
  }
}
function ia(e, t, r) {
  var n, s = !1;
  return n = e, fs({
    connector: function() {
      return new xi(n, t, r);
    },
    resetOnError: !0,
    resetOnComplete: !1,
    resetOnRefCountZero: s
  });
}
function aa(e, t, r) {
  var n = U(e) || t || r ? { next: e, error: t, complete: r } : e;
  return n ? se(function(s, o) {
    var i;
    (i = n.subscribe) === null || i === void 0 || i.call(n);
    var a = !0;
    s.subscribe(Ce(o, function(u) {
      var c;
      (c = n.next) === null || c === void 0 || c.call(n, u), o.next(u);
    }, function() {
      var u;
      a = !1, (u = n.complete) === null || u === void 0 || u.call(n), o.complete();
    }, function(u) {
      var c;
      a = !1, (c = n.error) === null || c === void 0 || c.call(n, u), o.error(u);
    }, function() {
      var u, c;
      a && ((u = n.unsubscribe) === null || u === void 0 || u.call(n)), (c = n.finalize) === null || c === void 0 || c.call(n);
    }));
  }) : Mt;
}
var ds = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, Ar = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 }, ua = new Array(4).fill(String.fromCodePoint(Ar[0])).join("");
function ca(e) {
  let t = JSON.stringify(e);
  return `${ua}${Array.from(t).map((r) => {
    let n = r.charCodeAt(0);
    if (n > 255) throw new Error(`Only ASCII edit info can be encoded. Error attempting to encode ${t} on character ${r} (${n})`);
    return Array.from(n.toString(4).padStart(4, "0")).map((s) => String.fromCodePoint(Ar[s])).join("");
  }).join("")}`;
}
function la(e) {
  return !Number.isNaN(Number(e)) || /[a-z]/i.test(e) && !/\d+(?:[-:\/]\d+){2}(?:T\d+(?:[-:\/]\d+){1,2}(\.\d+)?Z?)?/.test(e) ? !1 : !!Date.parse(e);
}
function fa(e) {
  try {
    new URL(e, e.startsWith("/") ? "https://acme.com" : void 0);
  } catch {
    return !1;
  }
  return !0;
}
function _l(e, t, r = "auto") {
  return r === !0 || r === "auto" && (la(e) || fa(e)) ? e : `${e}${ca(t)}`;
}
Object.fromEntries(Object.entries(Ar).map((e) => e.reverse()));
Object.fromEntries(Object.entries(ds).map((e) => e.reverse()));
var da = `${Object.values(ds).map((e) => `\\u{${e.toString(16)}}`).join("")}`, sn = new RegExp(`[${da}]{4,}`, "gu");
function ha(e) {
  var t;
  return { cleaned: e.replace(sn, ""), encoded: ((t = e.match(sn)) == null ? void 0 : t[0]) || "" };
}
function pa(e) {
  return e && JSON.parse(ha(JSON.stringify(e)).cleaned);
}
function ma(e) {
  return pa(e);
}
class ya extends Error {
  constructor(r) {
    const n = hs(r);
    super(n.message);
    _(this, "response");
    _(this, "statusCode", 400);
    _(this, "responseBody");
    _(this, "details");
    Object.assign(this, n);
  }
}
class ba extends Error {
  constructor(r) {
    const n = hs(r);
    super(n.message);
    _(this, "response");
    _(this, "statusCode", 500);
    _(this, "responseBody");
    _(this, "details");
    Object.assign(this, n);
  }
}
function hs(e) {
  const t = e.body, r = {
    response: e,
    statusCode: e.statusCode,
    responseBody: Ea(t, e),
    message: "",
    details: void 0
  };
  if (t.error && t.message)
    return r.message = `${t.error} - ${t.message}`, r;
  if (ga(t) || wa(t)) {
    const n = t.error.items || [], s = n.slice(0, 5).map((i) => {
      var a;
      return (a = i.error) == null ? void 0 : a.description;
    }).filter(Boolean);
    let o = s.length ? `:
- ${s.join(`
- `)}` : "";
    return n.length > 5 && (o += `
...and ${n.length - 5} more`), r.message = `${t.error.description}${o}`, r.details = t.error, r;
  }
  return t.error && t.error.description ? (r.message = t.error.description, r.details = t.error, r) : (r.message = t.error || t.message || va(e), r);
}
function ga(e) {
  return $t(e) && $t(e.error) && e.error.type === "mutationError" && typeof e.error.description == "string";
}
function wa(e) {
  return $t(e) && $t(e.error) && e.error.type === "actionError" && typeof e.error.description == "string";
}
function $t(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function va(e) {
  const t = e.statusMessage ? ` ${e.statusMessage}` : "";
  return `${e.method}-request to ${e.url} resulted in HTTP ${e.statusCode}${t}`;
}
function Ea(e, t) {
  return (t.headers["content-type"] || "").toLowerCase().indexOf("application/json") !== -1 ? JSON.stringify(e, null, 2) : e;
}
class Sa extends Error {
  constructor({ projectId: r }) {
    super("CorsOriginError");
    _(this, "projectId");
    _(this, "addOriginUrl");
    this.name = "CorsOriginError", this.projectId = r;
    const n = new URL(`https://sanity.io/manage/project/${r}/api`);
    if (typeof location < "u") {
      const { origin: s } = location;
      n.searchParams.set("cors", "add"), n.searchParams.set("origin", s), this.addOriginUrl = n, this.message = `The current origin is not allowed to connect to the Live Content API. Add it here: ${n}`;
    } else
      this.message = `The current origin is not allowed to connect to the Live Content API. Change your configuration here: ${n}`;
  }
}
const Ca = {
  onResponse: (e) => {
    if (e.statusCode >= 500)
      throw new ba(e);
    if (e.statusCode >= 400)
      throw new ya(e);
    return e;
  }
};
function xa() {
  const e = {};
  return {
    onResponse: (t) => {
      const r = t.headers["x-sanity-warning"], n = Array.isArray(r) ? r : [r];
      for (const s of n)
        !s || e[s] || (e[s] = !0, console.warn(s));
      return t;
    }
  };
}
function on(e) {
  return ei([
    br({ shouldRetry: Oa }),
    ...e,
    xa(),
    si(),
    oi(),
    ui(),
    Ca,
    ai({ implementation: N })
  ]);
}
function Oa(e, t, r) {
  if (r.maxRetries === 0) return !1;
  const n = r.method === "GET" || r.method === "HEAD", s = (r.uri || r.url).startsWith("/data/query"), o = e.response && (e.response.statusCode === 429 || e.response.statusCode === 502 || e.response.statusCode === 503);
  return (n || s) && o ? !0 : br.shouldRetry(e, t, r);
}
const Aa = "https://www.sanity.io/help/";
function Rr(e) {
  return Aa + e;
}
const an = ["image", "file"], un = ["before", "after", "replace"], ps = (e) => {
  if (!/^(~[a-z0-9]{1}[-\w]{0,63}|[a-z0-9]{1}[-\w]{0,63})$/.test(e))
    throw new Error(
      "Datasets can only contain lowercase characters, numbers, underscores and dashes, and start with tilde, and be maximum 64 characters"
    );
}, Ra = (e) => {
  if (!/^[-a-z0-9]+$/i.test(e))
    throw new Error("`projectId` can only contain only a-z, 0-9 and dashes");
}, _a = (e) => {
  if (an.indexOf(e) === -1)
    throw new Error(`Invalid asset type: ${e}. Must be one of ${an.join(", ")}`);
}, et = (e, t) => {
  if (t === null || typeof t != "object" || Array.isArray(t))
    throw new Error(`${e}() takes an object of properties`);
}, ms = (e, t) => {
  if (typeof t != "string" || !/^[a-z0-9_][a-z0-9_.-]{0,127}$/i.test(t) || t.includes(".."))
    throw new Error(`${e}(): "${t}" is not a valid document ID`);
}, kt = (e, t) => {
  if (!t._id)
    throw new Error(`${e}() requires that the document contains an ID ("_id" property)`);
  ms(e, t._id);
}, Ta = (e, t, r) => {
  const n = "insert(at, selector, items)";
  if (un.indexOf(e) === -1) {
    const s = un.map((o) => `"${o}"`).join(", ");
    throw new Error(`${n} takes an "at"-argument which is one of: ${s}`);
  }
  if (typeof t != "string")
    throw new Error(`${n} takes a "selector"-argument which must be a string`);
  if (!Array.isArray(r))
    throw new Error(`${n} takes an "items"-argument which must be an array`);
}, ys = (e) => {
  if (!e.dataset)
    throw new Error("`dataset` must be provided to perform queries");
  return e.dataset || "";
}, bs = (e) => {
  if (typeof e != "string" || !/^[a-z0-9._-]{1,75}$/i.test(e))
    throw new Error(
      "Tag can only contain alphanumeric characters, underscores, dashes and dots, and be between one and 75 characters long."
    );
  return e;
};
function Ia(e) {
  let t = !1, r;
  return (...n) => (t || (r = e(...n), t = !0), r);
}
const Ve = (e) => (
  // eslint-disable-next-line no-console
  Ia((...t) => console.warn(e.join(" "), ...t))
), Pa = Ve([
  "Because you set `withCredentials` to true, we will override your `useCdn`",
  "setting to be false since (cookie-based) credentials are never set on the CDN"
]), ja = Ve([
  "Since you haven't set a value for `useCdn`, we will deliver content using our",
  "global, edge-cached API-CDN. If you wish to have content delivered faster, set",
  "`useCdn: false` to use the Live API. Note: You may incur higher costs using the live API."
]), $a = Ve([
  "The Sanity client is configured with the `perspective` set to `drafts` or `previewDrafts`, which doesn't support the API-CDN.",
  "The Live API will be used instead. Set `useCdn: false` in your configuration to hide this warning."
]), ka = Ve([
  "The `previewDrafts` perspective has been renamed to  `drafts` and will be removed in a future API version"
]), Fa = Ve([
  "You have configured Sanity client to use a token in the browser. This may cause unintentional security issues.",
  `See ${Rr(
    "js-client-browser-token"
  )} for more information and how to hide this warning.`
]), Ua = Ve([
  "Using the Sanity client without specifying an API version is deprecated.",
  `See ${Rr("js-client-api-version")}`
]), Na = "apicdn.sanity.io", tt = {
  apiHost: "https://api.sanity.io",
  apiVersion: "1",
  useProjectHostname: !0,
  stega: { enabled: !1 }
}, qa = ["localhost", "127.0.0.1", "0.0.0.0"], Da = (e) => qa.indexOf(e) !== -1;
function La(e) {
  if (e === "1" || e === "X")
    return;
  const t = new Date(e);
  if (!(/^\d{4}-\d{2}-\d{2}$/.test(e) && t instanceof Date && t.getTime() > 0))
    throw new Error("Invalid API version string, expected `1` or date in format `YYYY-MM-DD`");
}
const Ma = /^[a-z0-9_]+$/i;
function gs(e) {
  if (Array.isArray(e) && e.includes("raw"))
    throw new TypeError(
      'Invalid API perspective value: "raw". The raw-perspective can not be combined with other perspectives'
    );
  const t = (Array.isArray(e) ? e : [e]).filter(
    (r) => typeof r != "string" || !Ma.test(r)
  );
  if (t.length > 0) {
    const r = t.map((n) => JSON.stringify(n));
    throw new TypeError(
      `Invalid API perspective value${t.length === 1 ? "" : "s"}: ${r.join(", ")}, expected \`published\`, \`drafts\`, \`raw\` or a release identifier string`
    );
  }
}
const ws = (e, t) => {
  const r = {
    ...t,
    ...e,
    stega: {
      ...typeof t.stega == "boolean" ? { enabled: t.stega } : t.stega || tt.stega,
      ...typeof e.stega == "boolean" ? { enabled: e.stega } : e.stega || {}
    }
  };
  r.apiVersion || Ua();
  const n = {
    ...tt,
    ...r
  }, s = n.useProjectHostname;
  if (typeof Promise > "u") {
    const f = Rr("js-client-promise-polyfill");
    throw new Error(`No native Promise-implementation found, polyfill needed - see ${f}`);
  }
  if (s && !n.projectId)
    throw new Error("Configuration must contain `projectId`");
  if (typeof n.perspective < "u" && gs(n.perspective), "encodeSourceMap" in n)
    throw new Error(
      "It looks like you're using options meant for '@sanity/preview-kit/client'. 'encodeSourceMap' is not supported in '@sanity/client'. Did you mean 'stega.enabled'?"
    );
  if ("encodeSourceMapAtPath" in n)
    throw new Error(
      "It looks like you're using options meant for '@sanity/preview-kit/client'. 'encodeSourceMapAtPath' is not supported in '@sanity/client'. Did you mean 'stega.filter'?"
    );
  if (typeof n.stega.enabled != "boolean")
    throw new Error(`stega.enabled must be a boolean, received ${n.stega.enabled}`);
  if (n.stega.enabled && n.stega.studioUrl === void 0)
    throw new Error("stega.studioUrl must be defined when stega.enabled is true");
  if (n.stega.enabled && typeof n.stega.studioUrl != "string" && typeof n.stega.studioUrl != "function")
    throw new Error(
      `stega.studioUrl must be a string or a function, received ${n.stega.studioUrl}`
    );
  const o = typeof window < "u" && window.location && window.location.hostname, i = o && Da(window.location.hostname);
  o && i && n.token && n.ignoreBrowserTokenWarning !== !0 ? Fa() : typeof n.useCdn > "u" && ja(), s && Ra(n.projectId), n.dataset && ps(n.dataset), "requestTagPrefix" in n && (n.requestTagPrefix = n.requestTagPrefix ? bs(n.requestTagPrefix).replace(/\.+$/, "") : void 0), n.apiVersion = `${n.apiVersion}`.replace(/^v/, ""), n.isDefaultApi = n.apiHost === tt.apiHost, n.useCdn === !0 && n.withCredentials && Pa(), n.useCdn = n.useCdn !== !1 && !n.withCredentials, La(n.apiVersion);
  const a = n.apiHost.split("://", 2), u = a[0], c = a[1], l = n.isDefaultApi ? Na : c;
  return n.useProjectHostname ? (n.url = `${u}://${n.projectId}.${c}/v${n.apiVersion}`, n.cdnUrl = `${u}://${n.projectId}.${l}/v${n.apiVersion}`) : (n.url = `${n.apiHost}/v${n.apiVersion}`, n.cdnUrl = n.url), n;
};
class vs extends Error {
  constructor() {
    super(...arguments);
    _(this, "name", "ConnectionFailedError");
  }
}
class Ba extends Error {
  constructor(r, n, s = {}) {
    super(r, s);
    _(this, "name", "DisconnectError");
    _(this, "reason");
    this.reason = n;
  }
}
class Ha extends Error {
  constructor(r, n) {
    super(r);
    _(this, "name", "ChannelError");
    _(this, "data");
    this.data = n;
  }
}
class za extends Error {
  constructor(r, n, s = {}) {
    super(r, s);
    _(this, "name", "MessageError");
    _(this, "data");
    this.data = n;
  }
}
class cn extends Error {
  constructor() {
    super(...arguments);
    _(this, "name", "MessageParseError");
  }
}
const Va = ["channelError", "disconnect"];
function Es(e, t) {
  return us(() => {
    const r = e();
    return Wi(r) ? r : Bt(r);
  }).pipe(Et((r) => Wa(r, t)));
}
function Wa(e, t) {
  return new N((r) => {
    const n = t.includes("open"), s = t.includes("reconnect");
    function o(c) {
      if ("data" in c) {
        const [l, f] = ln(c);
        r.error(
          l ? new cn("Unable to parse EventSource error message", { cause: f }) : new za((f == null ? void 0 : f.data).message, f)
        );
        return;
      }
      e.readyState === e.CLOSED ? r.error(new vs("EventSource connection failed")) : s && r.next({ type: "reconnect" });
    }
    function i() {
      r.next({ type: "open" });
    }
    function a(c) {
      var g;
      const [l, f] = ln(c);
      if (l) {
        r.error(
          new cn("Unable to parse EventSource message", { cause: l })
        );
        return;
      }
      if (c.type === "channelError") {
        r.error(new Ha(Ja(f == null ? void 0 : f.data), f.data));
        return;
      }
      if (c.type === "disconnect") {
        r.error(
          new Ba(
            `Server disconnected client: ${((g = f.data) == null ? void 0 : g.reason) || "unknown error"}`
          )
        );
        return;
      }
      r.next({
        type: c.type,
        id: c.lastEventId,
        ...f.data ? { data: f.data } : {}
      });
    }
    e.addEventListener("error", o), n && e.addEventListener("open", i);
    const u = [.../* @__PURE__ */ new Set([...Va, ...t])].filter((c) => c !== "error" && c !== "open" && c !== "reconnect");
    return u.forEach((c) => e.addEventListener(c, a)), () => {
      e.removeEventListener("error", o), n && e.removeEventListener("open", i), u.forEach((c) => e.removeEventListener(c, a)), e.close();
    };
  });
}
function ln(e) {
  try {
    const t = typeof e.data == "string" && JSON.parse(e.data);
    return [
      null,
      {
        type: e.type,
        id: e.lastEventId,
        ...Ga(t) ? {} : { data: t }
      }
    ];
  } catch (t) {
    return [t, null];
  }
}
function Ja(e) {
  return e.error ? e.error.description ? e.error.description : typeof e.error == "string" ? e.error : JSON.stringify(e.error, null, 2) : e.message || "Unknown listener error";
}
function Ga(e) {
  for (const t in e)
    return !1;
  return !0;
}
function Ss(e) {
  if (typeof e == "string")
    return { id: e };
  if (Array.isArray(e))
    return { query: "*[_id in $ids]", params: { ids: e } };
  if (typeof e == "object" && e !== null && "query" in e && typeof e.query == "string")
    return "params" in e && typeof e.params == "object" && e.params !== null ? { query: e.query, params: e.params } : { query: e.query };
  const t = [
    "* Document ID (<docId>)",
    "* Array of document IDs",
    "* Object containing `query`"
  ].join(`
`);
  throw new Error(`Unknown selection - must be one of:

${t}`);
}
class Cs {
  constructor(t, r = {}) {
    _(this, "selection");
    _(this, "operations");
    this.selection = t, this.operations = r;
  }
  /**
   * Sets the given attributes to the document. Does NOT merge objects.
   * The operation is added to the current patch, ready to be commited by `commit()`
   *
   * @param attrs - Attributes to set. To set a deep attribute, use JSONMatch, eg: \{"nested.prop": "value"\}
   */
  set(t) {
    return this._assign("set", t);
  }
  /**
   * Sets the given attributes to the document if they are not currently set. Does NOT merge objects.
   * The operation is added to the current patch, ready to be commited by `commit()`
   *
   * @param attrs - Attributes to set. To set a deep attribute, use JSONMatch, eg: \{"nested.prop": "value"\}
   */
  setIfMissing(t) {
    return this._assign("setIfMissing", t);
  }
  /**
   * Performs a "diff-match-patch" operation on the string attributes provided.
   * The operation is added to the current patch, ready to be commited by `commit()`
   *
   * @param attrs - Attributes to perform operation on. To set a deep attribute, use JSONMatch, eg: \{"nested.prop": "dmp"\}
   */
  diffMatchPatch(t) {
    return et("diffMatchPatch", t), this._assign("diffMatchPatch", t);
  }
  /**
   * Unsets the attribute paths provided.
   * The operation is added to the current patch, ready to be commited by `commit()`
   *
   * @param attrs - Attribute paths to unset.
   */
  unset(t) {
    if (!Array.isArray(t))
      throw new Error("unset(attrs) takes an array of attributes to unset, non-array given");
    return this.operations = Object.assign({}, this.operations, { unset: t }), this;
  }
  /**
   * Increment a numeric value. Each entry in the argument is either an attribute or a JSON path. The value may be a positive or negative integer or floating-point value. The operation will fail if target value is not a numeric value, or doesn't exist.
   *
   * @param attrs - Object of attribute paths to increment, values representing the number to increment by.
   */
  inc(t) {
    return this._assign("inc", t);
  }
  /**
   * Decrement a numeric value. Each entry in the argument is either an attribute or a JSON path. The value may be a positive or negative integer or floating-point value. The operation will fail if target value is not a numeric value, or doesn't exist.
   *
   * @param attrs - Object of attribute paths to decrement, values representing the number to decrement by.
   */
  dec(t) {
    return this._assign("dec", t);
  }
  /**
   * Provides methods for modifying arrays, by inserting, appending and replacing elements via a JSONPath expression.
   *
   * @param at - Location to insert at, relative to the given selector, or 'replace' the matched path
   * @param selector - JSONPath expression, eg `comments[-1]` or `blocks[_key=="abc123"]`
   * @param items - Array of items to insert/replace
   */
  insert(t, r, n) {
    return Ta(t, r, n), this._assign("insert", { [t]: r, items: n });
  }
  /**
   * Append the given items to the array at the given JSONPath
   *
   * @param selector - Attribute/path to append to, eg `comments` or `person.hobbies`
   * @param items - Array of items to append to the array
   */
  append(t, r) {
    return this.insert("after", `${t}[-1]`, r);
  }
  /**
   * Prepend the given items to the array at the given JSONPath
   *
   * @param selector - Attribute/path to prepend to, eg `comments` or `person.hobbies`
   * @param items - Array of items to prepend to the array
   */
  prepend(t, r) {
    return this.insert("before", `${t}[0]`, r);
  }
  /**
   * Change the contents of an array by removing existing elements and/or adding new elements.
   *
   * @param selector - Attribute or JSONPath expression for array
   * @param start - Index at which to start changing the array (with origin 0). If greater than the length of the array, actual starting index will be set to the length of the array. If negative, will begin that many elements from the end of the array (with origin -1) and will be set to 0 if absolute value is greater than the length of the array.x
   * @param deleteCount - An integer indicating the number of old array elements to remove.
   * @param items - The elements to add to the array, beginning at the start index. If you don't specify any elements, splice() will only remove elements from the array.
   */
  splice(t, r, n, s) {
    const o = typeof n > "u" || n === -1, i = r < 0 ? r - 1 : r, a = o ? -1 : Math.max(0, r + n), u = i < 0 && a >= 0 ? "" : a, c = `${t}[${i}:${u}]`;
    return this.insert("replace", c, s || []);
  }
  /**
   * Adds a revision clause, preventing the document from being patched if the `_rev` property does not match the given value
   *
   * @param rev - Revision to lock the patch to
   */
  ifRevisionId(t) {
    return this.operations.ifRevisionID = t, this;
  }
  /**
   * Return a plain JSON representation of the patch
   */
  serialize() {
    return { ...Ss(this.selection), ...this.operations };
  }
  /**
   * Return a plain JSON representation of the patch
   */
  toJSON() {
    return this.serialize();
  }
  /**
   * Clears the patch of all operations
   */
  reset() {
    return this.operations = {}, this;
  }
  _assign(t, r, n = !0) {
    return et(t, r), this.operations = Object.assign({}, this.operations, {
      [t]: Object.assign({}, n && this.operations[t] || {}, r)
    }), this;
  }
  _set(t, r) {
    return this._assign(t, r, !1);
  }
}
var Ae;
const $r = class $r extends Cs {
  constructor(r, n, s) {
    super(r, n);
    j(this, Ae);
    P(this, Ae, s);
  }
  /**
   * Clones the patch
   */
  clone() {
    return new $r(this.selection, { ...this.operations }, w(this, Ae));
  }
  commit(r) {
    if (!w(this, Ae))
      throw new Error(
        "No `client` passed to patch, either provide one or pass the patch to a clients `mutate()` method"
      );
    const n = typeof this.selection == "string", s = Object.assign({ returnFirst: n, returnDocuments: !0 }, r);
    return w(this, Ae).mutate({ patch: this.serialize() }, s);
  }
};
Ae = new WeakMap();
let Ie = $r;
var Re;
const kr = class kr extends Cs {
  constructor(r, n, s) {
    super(r, n);
    j(this, Re);
    P(this, Re, s);
  }
  /**
   * Clones the patch
   */
  clone() {
    return new kr(this.selection, { ...this.operations }, w(this, Re));
  }
  commit(r) {
    if (!w(this, Re))
      throw new Error(
        "No `client` passed to patch, either provide one or pass the patch to a clients `mutate()` method"
      );
    const n = typeof this.selection == "string", s = Object.assign({ returnFirst: n, returnDocuments: !0 }, r);
    return w(this, Re).mutate({ patch: this.serialize() }, s);
  }
};
Re = new WeakMap();
let Se = kr;
const xs = { returnDocuments: !1 };
class Os {
  constructor(t = [], r) {
    _(this, "operations");
    _(this, "trxId");
    this.operations = t, this.trxId = r;
  }
  /**
   * Creates a new Sanity document. If `_id` is provided and already exists, the mutation will fail. If no `_id` is given, one will automatically be generated by the database.
   * The operation is added to the current transaction, ready to be commited by `commit()`
   *
   * @param doc - Document to create. Requires a `_type` property.
   */
  create(t) {
    return et("create", t), this._add({ create: t });
  }
  /**
   * Creates a new Sanity document. If a document with the same `_id` already exists, the create operation will be ignored.
   * The operation is added to the current transaction, ready to be commited by `commit()`
   *
   * @param doc - Document to create if it does not already exist. Requires `_id` and `_type` properties.
   */
  createIfNotExists(t) {
    const r = "createIfNotExists";
    return et(r, t), kt(r, t), this._add({ [r]: t });
  }
  /**
   * Creates a new Sanity document, or replaces an existing one if the same `_id` is already used.
   * The operation is added to the current transaction, ready to be commited by `commit()`
   *
   * @param doc - Document to create or replace. Requires `_id` and `_type` properties.
   */
  createOrReplace(t) {
    const r = "createOrReplace";
    return et(r, t), kt(r, t), this._add({ [r]: t });
  }
  /**
   * Deletes the document with the given document ID
   * The operation is added to the current transaction, ready to be commited by `commit()`
   *
   * @param documentId - Document ID to delete
   */
  delete(t) {
    return ms("delete", t), this._add({ delete: { id: t } });
  }
  transactionId(t) {
    return t ? (this.trxId = t, this) : this.trxId;
  }
  /**
   * Return a plain JSON representation of the transaction
   */
  serialize() {
    return [...this.operations];
  }
  /**
   * Return a plain JSON representation of the transaction
   */
  toJSON() {
    return this.serialize();
  }
  /**
   * Clears the transaction of all operations
   */
  reset() {
    return this.operations = [], this;
  }
  _add(t) {
    return this.operations.push(t), this;
  }
}
var ue;
const Fr = class Fr extends Os {
  constructor(r, n, s) {
    super(r, s);
    j(this, ue);
    P(this, ue, n);
  }
  /**
   * Clones the transaction
   */
  clone() {
    return new Fr([...this.operations], w(this, ue), this.trxId);
  }
  commit(r) {
    if (!w(this, ue))
      throw new Error(
        "No `client` passed to transaction, either provide one or pass the transaction to a clients `mutate()` method"
      );
    return w(this, ue).mutate(
      this.serialize(),
      Object.assign({ transactionId: this.trxId }, xs, r || {})
    );
  }
  patch(r, n) {
    const s = typeof n == "function", o = typeof r != "string" && r instanceof Se, i = typeof r == "object" && ("query" in r || "id" in r);
    if (o)
      return this._add({ patch: r.serialize() });
    if (s) {
      const a = n(new Se(r, {}, w(this, ue)));
      if (!(a instanceof Se))
        throw new Error("function passed to `patch()` must return the patch");
      return this._add({ patch: a.serialize() });
    }
    if (i) {
      const a = new Se(r, n || {}, w(this, ue));
      return this._add({ patch: a.serialize() });
    }
    return this._add({ patch: { id: r, ...n } });
  }
};
ue = new WeakMap();
let Ft = Fr;
var be;
const Ur = class Ur extends Os {
  constructor(r, n, s) {
    super(r, s);
    j(this, be);
    P(this, be, n);
  }
  /**
   * Clones the transaction
   */
  clone() {
    return new Ur([...this.operations], w(this, be), this.trxId);
  }
  commit(r) {
    if (!w(this, be))
      throw new Error(
        "No `client` passed to transaction, either provide one or pass the transaction to a clients `mutate()` method"
      );
    return w(this, be).mutate(
      this.serialize(),
      Object.assign({ transactionId: this.trxId }, xs, r || {})
    );
  }
  patch(r, n) {
    const s = typeof n == "function";
    if (typeof r != "string" && r instanceof Ie)
      return this._add({ patch: r.serialize() });
    if (s) {
      const o = n(new Ie(r, {}, w(this, be)));
      if (!(o instanceof Ie))
        throw new Error("function passed to `patch()` must return the patch");
      return this._add({ patch: o.serialize() });
    }
    return this._add({ patch: { id: r, ...n } });
  }
};
be = new WeakMap();
let Ut = Ur;
const Ka = "X-Sanity-Project-ID";
function Qa(e, t = {}) {
  const r = {}, n = t.token || e.token;
  n && (r.Authorization = `Bearer ${n}`), !t.useGlobalApi && !e.useProjectHostname && e.projectId && (r[Ka] = e.projectId);
  const s = !!(typeof t.withCredentials > "u" ? e.token || e.withCredentials : t.withCredentials), o = typeof t.timeout > "u" ? e.timeout : t.timeout;
  return Object.assign({}, t, {
    headers: Object.assign({}, r, t.headers || {}),
    timeout: typeof o > "u" ? 5 * 60 * 1e3 : o,
    proxy: t.proxy || e.proxy,
    json: !0,
    withCredentials: s,
    fetch: typeof t.fetch == "object" && typeof e.fetch == "object" ? { ...e.fetch, ...t.fetch } : t.fetch || e.fetch
  });
}
const As = ({
  query: e,
  params: t = {},
  options: r = {}
}) => {
  const n = new URLSearchParams(), { tag: s, includeMutations: o, returnQuery: i, ...a } = r;
  s && n.append("tag", s), n.append("query", e);
  for (const [u, c] of Object.entries(t))
    n.append(`$${u}`, JSON.stringify(c));
  for (const [u, c] of Object.entries(a))
    c && n.append(u, `${c}`);
  return i === !1 && n.append("returnQuery", "false"), o === !1 && n.append("includeMutations", "false"), `?${n}`;
}, Xa = (e, t) => e === !1 ? void 0 : typeof e > "u" ? t : e, Ya = (e = {}) => ({
  dryRun: e.dryRun,
  returnIds: !0,
  returnDocuments: Xa(e.returnDocuments, !0),
  visibility: e.visibility || "sync",
  autoGenerateArrayKeys: e.autoGenerateArrayKeys,
  skipCrossDatasetReferenceValidation: e.skipCrossDatasetReferenceValidation
}), _r = (e) => e.type === "response", Za = (e) => e.body, eu = (e, t) => e.reduce((r, n) => (r[t(n)] = n, r), /* @__PURE__ */ Object.create(null)), tu = 11264;
function Rs(e, t, r, n, s = {}, o = {}) {
  const i = "stega" in o ? {
    ...r || {},
    ...typeof o.stega == "boolean" ? { enabled: o.stega } : o.stega || {}
  } : r, a = i.enabled ? ma(s) : s, u = o.filterResponse === !1 ? (p) => p : (p) => p.result, { cache: c, next: l, ...f } = {
    // Opt out of setting a `signal` on an internal `fetch` if one isn't provided.
    // This is necessary in React Server Components to avoid opting out of Request Memoization.
    useAbortSignal: typeof o.signal < "u",
    // Set `resultSourceMap' when stega is enabled, as it's required for encoding.
    resultSourceMap: i.enabled ? "withKeyArraySelector" : o.resultSourceMap,
    ...o,
    // Default to not returning the query, unless `filterResponse` is `false`,
    // or `returnQuery` is explicitly set. `true` is the default in Content Lake, so skip if truthy
    returnQuery: o.filterResponse === !1 && o.returnQuery !== !1
  }, g = typeof c < "u" || typeof l < "u" ? { ...f, fetch: { cache: c, next: l } } : f, m = We(e, t, "query", { query: n, params: a }, g);
  return i.enabled ? m.pipe(
    oa(
      vt(
        import("./stegaEncodeSourceMap-1V9XmNUB.js").then(function(p) {
          return p.stegaEncodeSourceMap$1;
        }).then(
          ({ stegaEncodeSourceMap: p }) => p
        )
      )
    ),
    V(
      ([p, h]) => {
        const v = h(p.result, p.resultSourceMap, i);
        return u({ ...p, result: v });
      }
    )
  ) : m.pipe(V(u));
}
function _s(e, t, r, n = {}) {
  const s = {
    uri: $e(e, "doc", r),
    json: !0,
    tag: n.tag,
    signal: n.signal
  };
  return St(e, t, s).pipe(
    ze(_r),
    V((o) => o.body.documents && o.body.documents[0])
  );
}
function Ts(e, t, r, n = {}) {
  const s = {
    uri: $e(e, "doc", r.join(",")),
    json: !0,
    tag: n.tag,
    signal: n.signal
  };
  return St(e, t, s).pipe(
    ze(_r),
    V((o) => {
      const i = eu(o.body.documents || [], (a) => a._id);
      return r.map((a) => i[a] || null);
    })
  );
}
function Is(e, t, r, n) {
  return kt("createIfNotExists", r), Ht(e, t, r, "createIfNotExists", n);
}
function Ps(e, t, r, n) {
  return kt("createOrReplace", r), Ht(e, t, r, "createOrReplace", n);
}
function js(e, t, r, n) {
  return We(
    e,
    t,
    "mutate",
    { mutations: [{ delete: Ss(r) }] },
    n
  );
}
function $s(e, t, r, n) {
  let s;
  r instanceof Se || r instanceof Ie ? s = { patch: r.serialize() } : r instanceof Ft || r instanceof Ut ? s = r.serialize() : s = r;
  const o = Array.isArray(s) ? s : [s], i = n && n.transactionId || void 0;
  return We(e, t, "mutate", { mutations: o, transactionId: i }, n);
}
function ks(e, t, r, n) {
  const s = Array.isArray(r) ? r : [r], o = n && n.transactionId || void 0, i = n && n.skipCrossDatasetReferenceValidation || void 0, a = n && n.dryRun || void 0;
  return We(
    e,
    t,
    "actions",
    { actions: s, transactionId: o, skipCrossDatasetReferenceValidation: i, dryRun: a },
    n
  );
}
function We(e, t, r, n, s = {}) {
  const o = r === "mutate", i = r === "actions", a = r === "query", u = o || i ? "" : As(n), c = !o && !i && u.length < tu, l = c ? u : "", f = s.returnFirst, { timeout: g, token: m, tag: p, headers: h, returnQuery: v, lastLiveEventId: x, cacheMode: C } = s, A = $e(e, r, l), I = {
    method: c ? "GET" : "POST",
    uri: A,
    json: !0,
    body: c ? void 0 : n,
    query: o && Ya(s),
    timeout: g,
    headers: h,
    token: m,
    tag: p,
    returnQuery: v,
    perspective: s.perspective,
    resultSourceMap: s.resultSourceMap,
    lastLiveEventId: Array.isArray(x) ? x[0] : x,
    cacheMode: C,
    canUseCdn: a,
    signal: s.signal,
    fetch: s.fetch,
    useAbortSignal: s.useAbortSignal,
    useCdn: s.useCdn
  };
  return St(e, t, I).pipe(
    ze(_r),
    V(Za),
    V((O) => {
      if (!o)
        return O;
      const $ = O.results || [];
      if (s.returnDocuments)
        return f ? $[0] && $[0].document : $.map((ye) => ye.document);
      const B = f ? "documentId" : "documentIds", me = f ? $[0] && $[0].id : $.map((ye) => ye.id);
      return {
        transactionId: O.transactionId,
        results: $,
        [B]: me
      };
    })
  );
}
function Ht(e, t, r, n, s = {}) {
  const o = { [n]: r }, i = Object.assign({ returnFirst: !0, returnDocuments: !0 }, s);
  return We(e, t, "mutate", { mutations: [o] }, i);
}
function St(e, t, r) {
  const n = r.url || r.uri, s = e.config(), o = typeof r.canUseCdn > "u" ? ["GET", "HEAD"].indexOf(r.method || "GET") >= 0 && n.indexOf("/data/") === 0 : r.canUseCdn;
  let i = (r.useCdn ?? s.useCdn) && o;
  const a = r.tag && s.requestTagPrefix ? [s.requestTagPrefix, r.tag].join(".") : r.tag || s.requestTagPrefix;
  if (a && r.tag !== null && (r.query = { tag: bs(a), ...r.query }), ["GET", "HEAD", "POST"].indexOf(r.method || "GET") >= 0 && n.indexOf("/data/query/") === 0) {
    const l = r.resultSourceMap ?? s.resultSourceMap;
    l !== void 0 && l !== !1 && (r.query = { resultSourceMap: l, ...r.query });
    const f = r.perspective || s.perspective;
    typeof f < "u" && (f === "previewDrafts" && ka(), gs(f), r.query = {
      perspective: Array.isArray(f) ? f.join(",") : f,
      ...r.query
    }, (Array.isArray(f) && f.length > 0 || // previewDrafts was renamed to drafts, but keep for backwards compat
    f === "previewDrafts" || f === "drafts") && i && (i = !1, $a())), r.lastLiveEventId && (r.query = { ...r.query, lastLiveEventId: r.lastLiveEventId }), r.returnQuery === !1 && (r.query = { returnQuery: "false", ...r.query }), i && r.cacheMode == "noStale" && (r.query = { cacheMode: "noStale", ...r.query });
  }
  const u = Qa(
    s,
    Object.assign({}, r, {
      url: Tr(e, n, i)
    })
  ), c = new N(
    (l) => t(u, s.requester).subscribe(l)
  );
  return r.signal ? c.pipe(ru(r.signal)) : c;
}
function ee(e, t, r) {
  return St(e, t, r).pipe(
    ze((n) => n.type === "response"),
    V((n) => n.body)
  );
}
function $e(e, t, r) {
  const n = e.config(), s = ys(n), o = `/${t}/${s}`;
  return `/data${r ? `${o}/${r}` : o}`.replace(/\/($|\?)/, "$1");
}
function Tr(e, t, r = !1) {
  const { url: n, cdnUrl: s } = e.config();
  return `${r ? s : n}/${t.replace(/^\//, "")}`;
}
function ru(e) {
  return (t) => new N((r) => {
    const n = () => r.error(su(e));
    if (e && e.aborted) {
      n();
      return;
    }
    const s = t.subscribe(r);
    return e.addEventListener("abort", n), () => {
      e.removeEventListener("abort", n), s.unsubscribe();
    };
  });
}
const nu = !!globalThis.DOMException;
function su(e) {
  if (nu)
    return new DOMException((e == null ? void 0 : e.reason) ?? "The operation was aborted.", "AbortError");
  const t = new Error((e == null ? void 0 : e.reason) ?? "The operation was aborted.");
  return t.name = "AbortError", t;
}
var lt, ft;
class ou {
  constructor(t, r) {
    j(this, lt);
    j(this, ft);
    P(this, lt, t), P(this, ft, r);
  }
  upload(t, r, n) {
    return Fs(w(this, lt), w(this, ft), t, r, n);
  }
}
lt = new WeakMap(), ft = new WeakMap();
var dt, ht;
class iu {
  constructor(t, r) {
    j(this, dt);
    j(this, ht);
    P(this, dt, t), P(this, ht, r);
  }
  upload(t, r, n) {
    const s = Fs(w(this, dt), w(this, ht), t, r, n);
    return M(
      s.pipe(
        ze((o) => o.type === "response"),
        V(
          (o) => o.body.document
        )
      )
    );
  }
}
dt = new WeakMap(), ht = new WeakMap();
function Fs(e, t, r, n, s = {}) {
  _a(r);
  let o = s.extract || void 0;
  o && !o.length && (o = ["none"]);
  const i = ys(e.config()), a = r === "image" ? "images" : "files", u = au(s, n), { tag: c, label: l, title: f, description: g, creditLine: m, filename: p, source: h } = u, v = {
    label: l,
    title: f,
    description: g,
    filename: p,
    meta: o,
    creditLine: m
  };
  return h && (v.sourceId = h.id, v.sourceName = h.name, v.sourceUrl = h.url), St(e, t, {
    tag: c,
    method: "POST",
    timeout: u.timeout || 0,
    uri: `/assets/${a}/${i}`,
    headers: u.contentType ? { "Content-Type": u.contentType } : {},
    query: v,
    body: n
  });
}
function au(e, t) {
  return typeof File > "u" || !(t instanceof File) ? e : Object.assign(
    {
      filename: e.preserveFilename === !1 ? void 0 : t.name,
      contentType: t.type
    },
    e
  );
}
var uu = (e, t) => Object.keys(t).concat(Object.keys(e)).reduce((r, n) => (r[n] = typeof e[n] > "u" ? t[n] : e[n], r), {});
const cu = (e, t) => t.reduce((r, n) => (typeof e[n] > "u" || (r[n] = e[n]), r), {}), Us = us(() => import("./browser-B3SNnJKK.js").then((e) => e.b)).pipe(
  V(({ default: e }) => e),
  ia(1)
);
function Ns() {
  return function(e) {
    return e.pipe(
      Or((t, r) => t instanceof vs ? as(Bt({ type: "reconnect" }), ta(1e3).pipe(Et(() => r))) : os(() => t))
    );
  };
}
const lu = 14800, fu = [
  "includePreviousRevision",
  "includeResult",
  "includeMutations",
  "includeAllVersions",
  "visibility",
  "effectFormat",
  "tag"
], du = {
  includeResult: !0
};
function qs(e, t, r = {}) {
  const { url: n, token: s, withCredentials: o, requestTagPrefix: i } = this.config(), a = r.tag && i ? [i, r.tag].join(".") : r.tag, u = { ...uu(r, du), tag: a }, c = cu(u, fu), l = As({ query: e, params: t, options: { tag: a, ...c } }), f = `${n}${$e(this, "listen", l)}`;
  if (f.length > lu)
    return os(() => new Error("Query too large for listener"));
  const g = u.events ? u.events : ["mutation"], m = {};
  return (s || o) && (m.withCredentials = !0), s && (m.headers = {
    Authorization: `Bearer ${s}`
  }), Es(() => (
    // use polyfill if there is no global EventSource or if we need to set headers
    (typeof EventSource > "u" || m.headers ? Us : Bt(EventSource)).pipe(V((p) => new p(f, m)))
  ), g).pipe(
    Ns(),
    ze((p) => g.includes(p.type)),
    V(
      (p) => ({
        type: p.type,
        ..."data" in p ? p.data : {}
      })
    )
  );
}
function hu(e, t) {
  return pu(
    typeof e == "function" ? { predicate: e, ...t } : e
  );
}
function pu(e) {
  return (t) => {
    let r, n = !1;
    const { predicate: s, ...o } = e, i = t.pipe(
      aa((u) => {
        e.predicate(u) && (n = !0, r = u);
      }),
      ls(() => {
        n = !1, r = void 0;
      }),
      fs(o)
    ), a = new N((u) => {
      n && u.next(r), u.complete();
    });
    return ra(i, a);
  };
}
const fn = "2021-03-25";
var _e;
class Ds {
  constructor(t) {
    j(this, _e);
    P(this, _e, t);
  }
  /**
   * Requires `apiVersion` to be `2021-03-25` or later.
   */
  events({
    includeDrafts: t = !1,
    tag: r
  } = {}) {
    const {
      projectId: n,
      apiVersion: s,
      token: o,
      withCredentials: i,
      requestTagPrefix: a
    } = w(this, _e).config(), u = s.replace(/^v/, "");
    if (u !== "X" && u < fn)
      throw new Error(
        `The live events API requires API version ${fn} or later. The current API version is ${u}. Please update your API version to use this feature.`
      );
    if (t && !o && !i)
      throw new Error(
        "The live events API requires a token or withCredentials when 'includeDrafts: true'. Please update your client configuration. The token should have the lowest possible access role."
      );
    const c = $e(w(this, _e), "live/events"), l = new URL(w(this, _e).getUrl(c, !1)), f = r && a ? [a, r].join(".") : r;
    f && l.searchParams.set("tag", f), t && l.searchParams.set("includeDrafts", "true");
    const g = {};
    t && o && (g.headers = {
      Authorization: `Bearer ${o}`
    }), t && i && (g.withCredentials = !0);
    const m = `${l.href}::${JSON.stringify(g)}`, p = tr.get(m);
    if (p)
      return p;
    const h = Es(() => (
      // use polyfill if there is no global EventSource or if we need to set headers
      (typeof EventSource > "u" || g.headers ? Us : Bt(EventSource)).pipe(V((C) => new C(l.href, g)))
    ), [
      "message",
      "restart",
      "welcome",
      "reconnect"
    ]).pipe(
      Ns(),
      V((C) => {
        if (C.type === "message") {
          const { data: A, ...I } = C;
          return { ...I, tags: A.tags };
        }
        return C;
      })
    ), v = mu(l, {
      method: "OPTIONS",
      mode: "cors",
      credentials: g.withCredentials ? "include" : "omit",
      headers: g.headers
    }).pipe(
      Et(() => Vn),
      Or(() => {
        throw new Sa({ projectId: n });
      })
    ), x = as(v, h).pipe(
      ls(() => tr.delete(m)),
      hu({
        predicate: (C) => C.type === "welcome"
      })
    );
    return tr.set(m, x), x;
  }
}
_e = new WeakMap();
function mu(e, t) {
  return new N((r) => {
    const n = new AbortController(), s = n.signal;
    return fetch(e, { ...t, signal: n.signal }).then(
      (o) => {
        r.next(o), r.complete();
      },
      (o) => {
        s.aborted || r.error(o);
      }
    ), () => n.abort();
  });
}
const tr = /* @__PURE__ */ new Map();
var ge, we;
class yu {
  constructor(t, r) {
    j(this, ge);
    j(this, we);
    P(this, ge, t), P(this, we, r);
  }
  /**
   * Create a new dataset with the given name
   *
   * @param name - Name of the dataset to create
   * @param options - Options for the dataset
   */
  create(t, r) {
    return Ue(w(this, ge), w(this, we), "PUT", t, r);
  }
  /**
   * Edit a dataset with the given name
   *
   * @param name - Name of the dataset to edit
   * @param options - New options for the dataset
   */
  edit(t, r) {
    return Ue(w(this, ge), w(this, we), "PATCH", t, r);
  }
  /**
   * Delete a dataset with the given name
   *
   * @param name - Name of the dataset to delete
   */
  delete(t) {
    return Ue(w(this, ge), w(this, we), "DELETE", t);
  }
  /**
   * Fetch a list of datasets for the configured project
   */
  list() {
    return ee(w(this, ge), w(this, we), {
      uri: "/datasets",
      tag: null
    });
  }
}
ge = new WeakMap(), we = new WeakMap();
var ve, Ee;
class bu {
  constructor(t, r) {
    j(this, ve);
    j(this, Ee);
    P(this, ve, t), P(this, Ee, r);
  }
  /**
   * Create a new dataset with the given name
   *
   * @param name - Name of the dataset to create
   * @param options - Options for the dataset
   */
  create(t, r) {
    return M(
      Ue(w(this, ve), w(this, Ee), "PUT", t, r)
    );
  }
  /**
   * Edit a dataset with the given name
   *
   * @param name - Name of the dataset to edit
   * @param options - New options for the dataset
   */
  edit(t, r) {
    return M(
      Ue(w(this, ve), w(this, Ee), "PATCH", t, r)
    );
  }
  /**
   * Delete a dataset with the given name
   *
   * @param name - Name of the dataset to delete
   */
  delete(t) {
    return M(Ue(w(this, ve), w(this, Ee), "DELETE", t));
  }
  /**
   * Fetch a list of datasets for the configured project
   */
  list() {
    return M(
      ee(w(this, ve), w(this, Ee), { uri: "/datasets", tag: null })
    );
  }
}
ve = new WeakMap(), Ee = new WeakMap();
function Ue(e, t, r, n, s) {
  return ps(n), ee(e, t, {
    method: r,
    uri: `/datasets/${n}`,
    body: s,
    tag: null
  });
}
var qe, De;
class gu {
  constructor(t, r) {
    j(this, qe);
    j(this, De);
    P(this, qe, t), P(this, De, r);
  }
  list(t) {
    const r = (t == null ? void 0 : t.includeMembers) === !1 ? "/projects?includeMembers=false" : "/projects";
    return ee(w(this, qe), w(this, De), { uri: r });
  }
  /**
   * Fetch a project by project ID
   *
   * @param projectId - ID of the project to fetch
   */
  getById(t) {
    return ee(w(this, qe), w(this, De), { uri: `/projects/${t}` });
  }
}
qe = new WeakMap(), De = new WeakMap();
var Le, Me;
class wu {
  constructor(t, r) {
    j(this, Le);
    j(this, Me);
    P(this, Le, t), P(this, Me, r);
  }
  list(t) {
    const r = (t == null ? void 0 : t.includeMembers) === !1 ? "/projects?includeMembers=false" : "/projects";
    return M(ee(w(this, Le), w(this, Me), { uri: r }));
  }
  /**
   * Fetch a project by project ID
   *
   * @param projectId - ID of the project to fetch
   */
  getById(t) {
    return M(
      ee(w(this, Le), w(this, Me), { uri: `/projects/${t}` })
    );
  }
}
Le = new WeakMap(), Me = new WeakMap();
var pt, mt;
class vu {
  constructor(t, r) {
    j(this, pt);
    j(this, mt);
    P(this, pt, t), P(this, mt, r);
  }
  /**
   * Fetch a user by user ID
   *
   * @param id - User ID of the user to fetch. If `me` is provided, a minimal response including the users role is returned.
   */
  getById(t) {
    return ee(
      w(this, pt),
      w(this, mt),
      { uri: `/users/${t}` }
    );
  }
}
pt = new WeakMap(), mt = new WeakMap();
var yt, bt;
class Eu {
  constructor(t, r) {
    j(this, yt);
    j(this, bt);
    P(this, yt, t), P(this, bt, r);
  }
  /**
   * Fetch a user by user ID
   *
   * @param id - User ID of the user to fetch. If `me` is provided, a minimal response including the users role is returned.
   */
  getById(t) {
    return M(
      ee(w(this, yt), w(this, bt), {
        uri: `/users/${t}`
      })
    );
  }
}
yt = new WeakMap(), bt = new WeakMap();
var ce, L;
const Dt = class Dt {
  constructor(t, r = tt) {
    _(this, "assets");
    _(this, "datasets");
    _(this, "live");
    _(this, "projects");
    _(this, "users");
    /**
     * Private properties
     */
    j(this, ce);
    j(this, L);
    /**
     * Instance properties
     */
    _(this, "listen", qs);
    this.config(r), P(this, L, t), this.assets = new ou(this, w(this, L)), this.datasets = new yu(this, w(this, L)), this.live = new Ds(this), this.projects = new gu(this, w(this, L)), this.users = new vu(this, w(this, L));
  }
  /**
   * Clone the client - returns a new instance
   */
  clone() {
    return new Dt(w(this, L), this.config());
  }
  config(t) {
    if (t === void 0)
      return { ...w(this, ce) };
    if (w(this, ce) && w(this, ce).allowReconfigure === !1)
      throw new Error(
        "Existing client instance cannot be reconfigured - use `withConfig(newConfig)` to return a new client"
      );
    return P(this, ce, ws(t, w(this, ce) || {})), this;
  }
  /**
   * Clone the client with a new (partial) configuration.
   *
   * @param newConfig - New client configuration properties, shallowly merged with existing configuration
   */
  withConfig(t) {
    const r = this.config();
    return new Dt(w(this, L), {
      ...r,
      ...t,
      stega: {
        ...r.stega || {},
        ...typeof (t == null ? void 0 : t.stega) == "boolean" ? { enabled: t.stega } : (t == null ? void 0 : t.stega) || {}
      }
    });
  }
  fetch(t, r, n) {
    return Rs(
      this,
      w(this, L),
      w(this, ce).stega,
      t,
      r,
      n
    );
  }
  /**
   * Fetch a single document with the given ID.
   *
   * @param id - Document ID to fetch
   * @param options - Request options
   */
  getDocument(t, r) {
    return _s(this, w(this, L), t, r);
  }
  /**
   * Fetch multiple documents in one request.
   * Should be used sparingly - performing a query is usually a better option.
   * The order/position of documents is preserved based on the original array of IDs.
   * If any of the documents are missing, they will be replaced by a `null` entry in the returned array
   *
   * @param ids - Document IDs to fetch
   * @param options - Request options
   */
  getDocuments(t, r) {
    return Ts(this, w(this, L), t, r);
  }
  create(t, r) {
    return Ht(this, w(this, L), t, "create", r);
  }
  createIfNotExists(t, r) {
    return Is(this, w(this, L), t, r);
  }
  createOrReplace(t, r) {
    return Ps(this, w(this, L), t, r);
  }
  delete(t, r) {
    return js(this, w(this, L), t, r);
  }
  mutate(t, r) {
    return $s(this, w(this, L), t, r);
  }
  /**
   * Create a new buildable patch of operations to perform
   *
   * @param selection - Document ID, an array of document IDs, or an object with `query` and optional `params`, defining which document(s) to patch
   * @param operations - Optional object of patch operations to initialize the patch instance with
   * @returns Patch instance - call `.commit()` to perform the operations defined
   */
  patch(t, r) {
    return new Ie(t, r, this);
  }
  /**
   * Create a new transaction of mutations
   *
   * @param operations - Optional array of mutation operations to initialize the transaction instance with
   */
  transaction(t) {
    return new Ut(t, this);
  }
  /**
   * Perform action operations against the configured dataset
   *
   * @param operations - Action operation(s) to execute
   * @param options - Action options
   */
  action(t, r) {
    return ks(this, w(this, L), t, r);
  }
  /**
   * Perform an HTTP request against the Sanity API
   *
   * @param options - Request options
   */
  request(t) {
    return ee(this, w(this, L), t);
  }
  /**
   * Get a Sanity API URL for the URI provided
   *
   * @param uri - URI/path to build URL for
   * @param canUseCdn - Whether or not to allow using the API CDN for this route
   */
  getUrl(t, r) {
    return Tr(this, t, r);
  }
  /**
   * Get a Sanity API URL for the data operation and path provided
   *
   * @param operation - Data operation (eg `query`, `mutate`, `listen` or similar)
   * @param path - Path to append after the operation
   */
  getDataUrl(t, r) {
    return $e(this, t, r);
  }
};
ce = new WeakMap(), L = new WeakMap();
let cr = Dt;
var le, q;
const Lt = class Lt {
  constructor(t, r = tt) {
    _(this, "assets");
    _(this, "datasets");
    _(this, "live");
    _(this, "projects");
    _(this, "users");
    /**
     * Observable version of the Sanity client, with the same configuration as the promise-based one
     */
    _(this, "observable");
    /**
     * Private properties
     */
    j(this, le);
    j(this, q);
    /**
     * Instance properties
     */
    _(this, "listen", qs);
    this.config(r), P(this, q, t), this.assets = new iu(this, w(this, q)), this.datasets = new bu(this, w(this, q)), this.live = new Ds(this), this.projects = new wu(this, w(this, q)), this.users = new Eu(this, w(this, q)), this.observable = new cr(t, r);
  }
  /**
   * Clone the client - returns a new instance
   */
  clone() {
    return new Lt(w(this, q), this.config());
  }
  config(t) {
    if (t === void 0)
      return { ...w(this, le) };
    if (w(this, le) && w(this, le).allowReconfigure === !1)
      throw new Error(
        "Existing client instance cannot be reconfigured - use `withConfig(newConfig)` to return a new client"
      );
    return this.observable && this.observable.config(t), P(this, le, ws(t, w(this, le) || {})), this;
  }
  /**
   * Clone the client with a new (partial) configuration.
   *
   * @param newConfig - New client configuration properties, shallowly merged with existing configuration
   */
  withConfig(t) {
    const r = this.config();
    return new Lt(w(this, q), {
      ...r,
      ...t,
      stega: {
        ...r.stega || {},
        ...typeof (t == null ? void 0 : t.stega) == "boolean" ? { enabled: t.stega } : (t == null ? void 0 : t.stega) || {}
      }
    });
  }
  fetch(t, r, n) {
    return M(
      Rs(
        this,
        w(this, q),
        w(this, le).stega,
        t,
        r,
        n
      )
    );
  }
  /**
   * Fetch a single document with the given ID.
   *
   * @param id - Document ID to fetch
   * @param options - Request options
   */
  getDocument(t, r) {
    return M(_s(this, w(this, q), t, r));
  }
  /**
   * Fetch multiple documents in one request.
   * Should be used sparingly - performing a query is usually a better option.
   * The order/position of documents is preserved based on the original array of IDs.
   * If any of the documents are missing, they will be replaced by a `null` entry in the returned array
   *
   * @param ids - Document IDs to fetch
   * @param options - Request options
   */
  getDocuments(t, r) {
    return M(Ts(this, w(this, q), t, r));
  }
  create(t, r) {
    return M(
      Ht(this, w(this, q), t, "create", r)
    );
  }
  createIfNotExists(t, r) {
    return M(
      Is(this, w(this, q), t, r)
    );
  }
  createOrReplace(t, r) {
    return M(
      Ps(this, w(this, q), t, r)
    );
  }
  delete(t, r) {
    return M(js(this, w(this, q), t, r));
  }
  mutate(t, r) {
    return M($s(this, w(this, q), t, r));
  }
  /**
   * Create a new buildable patch of operations to perform
   *
   * @param selection - Document ID, an array of document IDs, or an object with `query` and optional `params`, defining which document(s) to patch
   * @param operations - Optional object of patch operations to initialize the patch instance with
   * @returns Patch instance - call `.commit()` to perform the operations defined
   */
  patch(t, r) {
    return new Se(t, r, this);
  }
  /**
   * Create a new transaction of mutations
   *
   * @param operations - Optional array of mutation operations to initialize the transaction instance with
   */
  transaction(t) {
    return new Ft(t, this);
  }
  /**
   * Perform action operations against the configured dataset
   * Returns a promise that resolves to the transaction result
   *
   * @param operations - Action operation(s) to execute
   * @param options - Action options
   */
  action(t, r) {
    return M(ks(this, w(this, q), t, r));
  }
  /**
   * Perform a request against the Sanity API
   * NOTE: Only use this for Sanity API endpoints, not for your own APIs!
   *
   * @param options - Request options
   * @returns Promise resolving to the response body
   */
  request(t) {
    return M(ee(this, w(this, q), t));
  }
  /**
   * Perform an HTTP request a `/data` sub-endpoint
   * NOTE: Considered internal, thus marked as deprecated. Use `request` instead.
   *
   * @deprecated - Use `request()` or your own HTTP library instead
   * @param endpoint - Endpoint to hit (mutate, query etc)
   * @param body - Request body
   * @param options - Request options
   * @internal
   */
  dataRequest(t, r, n) {
    return M(We(this, w(this, q), t, r, n));
  }
  /**
   * Get a Sanity API URL for the URI provided
   *
   * @param uri - URI/path to build URL for
   * @param canUseCdn - Whether or not to allow using the API CDN for this route
   */
  getUrl(t, r) {
    return Tr(this, t, r);
  }
  /**
   * Get a Sanity API URL for the data operation and path provided
   *
   * @param operation - Data operation (eg `query`, `mutate`, `listen` or similar)
   * @param path - Path to append after the operation
   */
  getDataUrl(t, r) {
    return $e(this, t, r);
  }
};
le = new WeakMap(), q = new WeakMap();
let lr = Lt;
function Su(e, t) {
  return { requester: on(e), createClient: (r) => {
    const n = on(e);
    return new t(
      (s, o) => (o || n)({
        maxRedirects: 0,
        maxRetries: r.maxRetries,
        retryDelay: r.retryDelay,
        ...s
      }),
      r
    );
  } };
}
var Cu = [];
const xu = Su(Cu, lr), Ou = xu.createClient, Ls = Ou({
  projectId: "0ls0csm4",
  dataset: "production",
  token: "skF3I3GTefhnWc6ta4QSMIwXiCUlQ1DHc2UuHfSoL22XgPVAnI6SX0e3Sxh5lLw7EnaIM4RHkd4w0ihgdtI7LFv7bNVF9sYS2PYeH87oQZitkj1M26Yl5mBHNV3YSYrTKxki5Ni2ABxP8mI3QSWc9u1tUCY4o43vbvZ5U4q2T8Qje5BXKeV3",
  useCdn: !1,
  ignoreBrowserTokenWarning: !0,
  apiVersion: "2020-01-01"
}), Au = Wo(Ls), Ru = async (e, t = {}) => {
  try {
    return await Ls.fetch(e, t);
  } catch (r) {
    throw console.log("Error fetching cms: ", r), r;
  }
}, _u = (e) => Au.image(e), Ms = {
  fetchCms: Ru,
  resolveImage: _u
};
function Tu(e) {
  const t = [];
  return new Proxy(e, {
    apply(r, n, s) {
      const o = vo(s), i = t.find((u) => Eo(u.key, o));
      if (i)
        return i.value;
      const a = Reflect.apply(r, n, s);
      return t.push({ key: o, value: a }), a;
    }
  });
}
const Iu = Tu(Ms.fetchCms), Pu = async (e) => {
  const t = Array.isArray(e) ? e : [e], r = So(t), s = `*[_type == "pages" && ${`label in ${JSON.stringify(r)}`} && __i18n_lang == "no" && !(_id in path("drafts.**"))]`;
  return await Iu(s);
}, ju = () => ({
  fetchPagesCms: Pu
}), $u = () => {
  const e = (u) => {
    const c = u == null ? void 0 : u.icon;
    return c ? Ms.resolveImage(c).url() : "";
  }, t = (u, c) => u == null ? void 0 : u.find((l) => l.label === c);
  return {
    getIconUrl: e,
    getCmsItem: t,
    getCmsItemText: (u, c) => {
      const l = t(u, c);
      return (l == null ? void 0 : l.title) ?? "";
    },
    findIconAndResolveUrl: (u, c) => {
      if (!c)
        return "";
      const l = t(c, u);
      return l ? e(l) : "";
    },
    getServiceIcon: (u, c) => {
      const l = u == null ? void 0 : u.icons;
      if (l != null && l.length)
        return e(l[0]);
      const f = c == null ? void 0 : c.icons;
      return f != null && f.length ? e(f[0]) : "";
    },
    getServiceName: (u, c) => {
      const l = u == null ? void 0 : u.title, f = c == null ? void 0 : c.name;
      return l || f || "";
    },
    getServiceTypeCms: (u, c) => u == null ? void 0 : u.find(
      (l) => l.label === c
    ),
    getServiceCategoryCms: (u, c) => {
      var l;
      return (l = u == null ? void 0 : u.serviceCategories) == null ? void 0 : l.find(
        (f) => f.label === c
      );
    }
  };
}, ku = { class: "get-started" }, Fu = { class: "get-started__header" }, Uu = ["src"], Nu = { class: "get-started__main" }, qu = { class: "get-started__title" }, Du = { class: "get-started__description" }, Lu = { class: "get-started__opt-ins" }, Mu = /* @__PURE__ */ He({
  __name: "UserGetStarted",
  props: {
    isSubmitting: { type: Boolean },
    submissionError: { default: "" },
    termsAndConditionsLink: {}
  },
  emits: ["submit"],
  setup(e, { emit: t }) {
    const r = t, n = e, { fetchPagesCms: s } = ju(), { findIconAndResolveUrl: o, getCmsItem: i, getCmsItemText: a } = $u(), u = _n({
      error: "",
      form: {
        termsAndConditionsAccepted: !1,
        newsletterAccepted: !1,
        otherCommunicationsAccepted: !1
      },
      cms: void 0
    }), c = Q(
      () => {
        var O;
        return o("leadingIllustration", (O = u.cms) == null ? void 0 : O.icons);
      }
    ), l = Q(() => {
      var O;
      return ((O = u.cms) == null ? void 0 : O.title) || "";
    }), f = Q(() => {
      var O;
      return a((O = u.cms) == null ? void 0 : O.otherText, "description");
    }), g = Q(() => {
      var O;
      return i((O = u.cms) == null ? void 0 : O.forms, "consentForm");
    }), m = Q(() => {
      var B;
      const O = a((B = g.value) == null ? void 0 : B.inputs, "platformTermsAndConditions"), $ = Lr.render(O, {
        linkStart: "{{{ linkStart }}}",
        linkEnd: "{{{ linkEnd }}}"
      });
      return Lr.render($, {
        linkStart: `<a href="${n.termsAndConditionsLink}" target="_blank">`,
        linkEnd: "</a>"
      });
    }), p = Q(
      () => {
        var O;
        return a((O = g.value) == null ? void 0 : O.inputs, "newsletters");
      }
    ), h = Q(
      () => {
        var O;
        return a((O = g.value) == null ? void 0 : O.inputs, "otherCommunications");
      }
    ), v = Q(() => u.error || n.submissionError), x = () => {
      u.error = "";
    }, C = (O) => {
      u.form.termsAndConditionsAccepted = O, x();
    }, A = () => {
      if (!n.isSubmitting) {
        if (!u.form.termsAndConditionsAccepted) {
          u.error = "Du må akseptere Really! sine brukervilkår for å gå videre.";
          return;
        }
        r("submit", u.form);
      }
    };
    return (async () => {
      const O = await s("userPlatformOnboardingComponent");
      u.cms = O == null ? void 0 : O[0];
    })(), (O, $) => (Z(), fe("div", ku, [
      J("div", Fu, [
        c.value ? (Z(), fe("img", {
          key: 0,
          src: c.value,
          alt: "",
          class: "get-started__illustration"
        }, null, 8, Uu)) : Pt("", !0)
      ]),
      J("div", Nu, [
        J("div", null, [
          J("div", qu, rt(l.value), 1),
          J("div", Du, rt(f.value), 1)
        ]),
        J("div", Lu, [
          Ye(Xt, {
            "model-value": u.form.termsAndConditionsAccepted,
            "onUpdate:modelValue": C,
            label: m.value
          }, null, 8, ["model-value", "label"]),
          Ye(Xt, {
            modelValue: u.form.newsletterAccepted,
            "onUpdate:modelValue": $[0] || ($[0] = (B) => u.form.newsletterAccepted = B),
            label: p.value
          }, null, 8, ["modelValue", "label"]),
          Ye(Xt, {
            modelValue: u.form.otherCommunicationsAccepted,
            "onUpdate:modelValue": $[1] || ($[1] = (B) => u.form.otherCommunicationsAccepted = B),
            label: h.value
          }, null, 8, ["modelValue", "label"])
        ]),
        v.value ? (Z(), Rn(Fo, {
          key: 0,
          text: v.value
        }, null, 8, ["text"])) : Pt("", !0),
        J("div", null, [
          Ye(Ro, {
            variant: "primary",
            uppercase: !0,
            "is-submitting": O.isSubmitting,
            text: "Kom i gang",
            onClick: A
          }, null, 8, ["is-submitting"])
        ])
      ])
    ]));
  }
}), Tl = /* @__PURE__ */ gt(Mu, [["__scopeId", "data-v-44fc2677"]]), Il = (e) => ({
  x: e + "Hello",
  z: 1
});
function Bs(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Bu } = Object.prototype, { getPrototypeOf: Ir } = Object, zt = /* @__PURE__ */ ((e) => (t) => {
  const r = Bu.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), te = (e) => (e = e.toLowerCase(), (t) => zt(t) === e), Vt = (e) => (t) => typeof t === e, { isArray: Je } = Array, st = Vt("undefined");
function Hu(e) {
  return e !== null && !st(e) && e.constructor !== null && !st(e.constructor) && X(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Hs = te("ArrayBuffer");
function zu(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Hs(e.buffer), t;
}
const Vu = Vt("string"), X = Vt("function"), zs = Vt("number"), Wt = (e) => e !== null && typeof e == "object", Wu = (e) => e === !0 || e === !1, Rt = (e) => {
  if (zt(e) !== "object")
    return !1;
  const t = Ir(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Ju = te("Date"), Gu = te("File"), Ku = te("Blob"), Qu = te("FileList"), Xu = (e) => Wt(e) && X(e.pipe), Yu = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || X(e.append) && ((t = zt(e)) === "formdata" || // detect form-data instance
  t === "object" && X(e.toString) && e.toString() === "[object FormData]"));
}, Zu = te("URLSearchParams"), [ec, tc, rc, nc] = ["ReadableStream", "Request", "Response", "Headers"].map(te), sc = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ct(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, s;
  if (typeof e != "object" && (e = [e]), Je(e))
    for (n = 0, s = e.length; n < s; n++)
      t.call(null, e[n], n, e);
  else {
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
    let a;
    for (n = 0; n < i; n++)
      a = o[n], t.call(null, e[a], a, e);
  }
}
function Vs(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, s;
  for (; n-- > 0; )
    if (s = r[n], t === s.toLowerCase())
      return s;
  return null;
}
const Oe = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Ws = (e) => !st(e) && e !== Oe;
function fr() {
  const { caseless: e } = Ws(this) && this || {}, t = {}, r = (n, s) => {
    const o = e && Vs(t, s) || s;
    Rt(t[o]) && Rt(n) ? t[o] = fr(t[o], n) : Rt(n) ? t[o] = fr({}, n) : Je(n) ? t[o] = n.slice() : t[o] = n;
  };
  for (let n = 0, s = arguments.length; n < s; n++)
    arguments[n] && Ct(arguments[n], r);
  return t;
}
const oc = (e, t, r, { allOwnKeys: n } = {}) => (Ct(t, (s, o) => {
  r && X(s) ? e[o] = Bs(s, r) : e[o] = s;
}, { allOwnKeys: n }), e), ic = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), ac = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, uc = (e, t, r, n) => {
  let s, o, i;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), o = s.length; o-- > 0; )
      i = s[o], (!n || n(i, e, t)) && !a[i] && (t[i] = e[i], a[i] = !0);
    e = r !== !1 && Ir(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, cc = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, lc = (e) => {
  if (!e) return null;
  if (Je(e)) return e;
  let t = e.length;
  if (!zs(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, fc = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Ir(Uint8Array)), dc = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const o = s.value;
    t.call(e, o[0], o[1]);
  }
}, hc = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, pc = te("HTMLFormElement"), mc = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, s) {
    return n.toUpperCase() + s;
  }
), dn = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), yc = te("RegExp"), Js = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  Ct(r, (s, o) => {
    let i;
    (i = t(s, o, e)) !== !1 && (n[o] = i || s);
  }), Object.defineProperties(e, n);
}, bc = (e) => {
  Js(e, (t, r) => {
    if (X(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (X(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, gc = (e, t) => {
  const r = {}, n = (s) => {
    s.forEach((o) => {
      r[o] = !0;
    });
  };
  return Je(e) ? n(e) : n(String(e).split(t)), r;
}, wc = () => {
}, vc = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, rr = "abcdefghijklmnopqrstuvwxyz", hn = "0123456789", Gs = {
  DIGIT: hn,
  ALPHA: rr,
  ALPHA_DIGIT: rr + rr.toUpperCase() + hn
}, Ec = (e = 16, t = Gs.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function Sc(e) {
  return !!(e && X(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const Cc = (e) => {
  const t = new Array(10), r = (n, s) => {
    if (Wt(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[s] = n;
        const o = Je(n) ? [] : {};
        return Ct(n, (i, a) => {
          const u = r(i, s + 1);
          !st(u) && (o[a] = u);
        }), t[s] = void 0, o;
      }
    }
    return n;
  };
  return r(e, 0);
}, xc = te("AsyncFunction"), Oc = (e) => e && (Wt(e) || X(e)) && X(e.then) && X(e.catch), Ks = ((e, t) => e ? setImmediate : t ? ((r, n) => (Oe.addEventListener("message", ({ source: s, data: o }) => {
  s === Oe && o === r && n.length && n.shift()();
}, !1), (s) => {
  n.push(s), Oe.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  X(Oe.postMessage)
), Ac = typeof queueMicrotask < "u" ? queueMicrotask.bind(Oe) : typeof process < "u" && process.nextTick || Ks, d = {
  isArray: Je,
  isArrayBuffer: Hs,
  isBuffer: Hu,
  isFormData: Yu,
  isArrayBufferView: zu,
  isString: Vu,
  isNumber: zs,
  isBoolean: Wu,
  isObject: Wt,
  isPlainObject: Rt,
  isReadableStream: ec,
  isRequest: tc,
  isResponse: rc,
  isHeaders: nc,
  isUndefined: st,
  isDate: Ju,
  isFile: Gu,
  isBlob: Ku,
  isRegExp: yc,
  isFunction: X,
  isStream: Xu,
  isURLSearchParams: Zu,
  isTypedArray: fc,
  isFileList: Qu,
  forEach: Ct,
  merge: fr,
  extend: oc,
  trim: sc,
  stripBOM: ic,
  inherits: ac,
  toFlatObject: uc,
  kindOf: zt,
  kindOfTest: te,
  endsWith: cc,
  toArray: lc,
  forEachEntry: dc,
  matchAll: hc,
  isHTMLForm: pc,
  hasOwnProperty: dn,
  hasOwnProp: dn,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Js,
  freezeMethods: bc,
  toObjectSet: gc,
  toCamelCase: mc,
  noop: wc,
  toFiniteNumber: vc,
  findKey: Vs,
  global: Oe,
  isContextDefined: Ws,
  ALPHABET: Gs,
  generateString: Ec,
  isSpecCompliantForm: Sc,
  toJSONObject: Cc,
  isAsyncFn: xc,
  isThenable: Oc,
  setImmediate: Ks,
  asap: Ac
};
function T(e, t, r, n, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), s && (this.response = s, this.status = s.status ? s.status : null);
}
d.inherits(T, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: d.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Qs = T.prototype, Xs = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Xs[e] = { value: e };
});
Object.defineProperties(T, Xs);
Object.defineProperty(Qs, "isAxiosError", { value: !0 });
T.from = (e, t, r, n, s, o) => {
  const i = Object.create(Qs);
  return d.toFlatObject(e, i, function(u) {
    return u !== Error.prototype;
  }, (a) => a !== "isAxiosError"), T.call(i, e.message, t, r, n, s), i.cause = e, i.name = e.name, o && Object.assign(i, o), i;
};
const Rc = null;
function dr(e) {
  return d.isPlainObject(e) || d.isArray(e);
}
function Ys(e) {
  return d.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function pn(e, t, r) {
  return e ? e.concat(t).map(function(s, o) {
    return s = Ys(s), !r && o ? "[" + s + "]" : s;
  }).join(r ? "." : "") : t;
}
function _c(e) {
  return d.isArray(e) && !e.some(dr);
}
const Tc = d.toFlatObject(d, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Jt(e, t, r) {
  if (!d.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = d.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, v) {
    return !d.isUndefined(v[h]);
  });
  const n = r.metaTokens, s = r.visitor || l, o = r.dots, i = r.indexes, u = (r.Blob || typeof Blob < "u" && Blob) && d.isSpecCompliantForm(t);
  if (!d.isFunction(s))
    throw new TypeError("visitor must be a function");
  function c(p) {
    if (p === null) return "";
    if (d.isDate(p))
      return p.toISOString();
    if (!u && d.isBlob(p))
      throw new T("Blob is not supported. Use a Buffer instead.");
    return d.isArrayBuffer(p) || d.isTypedArray(p) ? u && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function l(p, h, v) {
    let x = p;
    if (p && !v && typeof p == "object") {
      if (d.endsWith(h, "{}"))
        h = n ? h : h.slice(0, -2), p = JSON.stringify(p);
      else if (d.isArray(p) && _c(p) || (d.isFileList(p) || d.endsWith(h, "[]")) && (x = d.toArray(p)))
        return h = Ys(h), x.forEach(function(A, I) {
          !(d.isUndefined(A) || A === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? pn([h], I, o) : i === null ? h : h + "[]",
            c(A)
          );
        }), !1;
    }
    return dr(p) ? !0 : (t.append(pn(v, h, o), c(p)), !1);
  }
  const f = [], g = Object.assign(Tc, {
    defaultVisitor: l,
    convertValue: c,
    isVisitable: dr
  });
  function m(p, h) {
    if (!d.isUndefined(p)) {
      if (f.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + h.join("."));
      f.push(p), d.forEach(p, function(x, C) {
        (!(d.isUndefined(x) || x === null) && s.call(
          t,
          x,
          d.isString(C) ? C.trim() : C,
          h,
          g
        )) === !0 && m(x, h ? h.concat(C) : [C]);
      }), f.pop();
    }
  }
  if (!d.isObject(e))
    throw new TypeError("data must be an object");
  return m(e), t;
}
function mn(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Pr(e, t) {
  this._pairs = [], e && Jt(e, this, t);
}
const Zs = Pr.prototype;
Zs.append = function(t, r) {
  this._pairs.push([t, r]);
};
Zs.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, mn);
  } : mn;
  return this._pairs.map(function(s) {
    return r(s[0]) + "=" + r(s[1]);
  }, "").join("&");
};
function Ic(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function eo(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || Ic;
  d.isFunction(r) && (r = {
    serialize: r
  });
  const s = r && r.serialize;
  let o;
  if (s ? o = s(t, r) : o = d.isURLSearchParams(t) ? t.toString() : new Pr(t, r).toString(n), o) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class yn {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    d.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const to = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Pc = typeof URLSearchParams < "u" ? URLSearchParams : Pr, jc = typeof FormData < "u" ? FormData : null, $c = typeof Blob < "u" ? Blob : null, kc = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Pc,
    FormData: jc,
    Blob: $c
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, jr = typeof window < "u" && typeof document < "u", hr = typeof navigator == "object" && navigator || void 0, Fc = jr && (!hr || ["ReactNative", "NativeScript", "NS"].indexOf(hr.product) < 0), Uc = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Nc = jr && window.location.href || "http://localhost", qc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: jr,
  hasStandardBrowserEnv: Fc,
  hasStandardBrowserWebWorkerEnv: Uc,
  navigator: hr,
  origin: Nc
}, Symbol.toStringTag, { value: "Module" })), H = {
  ...qc,
  ...kc
};
function Dc(e, t) {
  return Jt(e, new H.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, s, o) {
      return H.isNode && d.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Lc(e) {
  return d.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Mc(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const s = r.length;
  let o;
  for (n = 0; n < s; n++)
    o = r[n], t[o] = e[o];
  return t;
}
function ro(e) {
  function t(r, n, s, o) {
    let i = r[o++];
    if (i === "__proto__") return !0;
    const a = Number.isFinite(+i), u = o >= r.length;
    return i = !i && d.isArray(s) ? s.length : i, u ? (d.hasOwnProp(s, i) ? s[i] = [s[i], n] : s[i] = n, !a) : ((!s[i] || !d.isObject(s[i])) && (s[i] = []), t(r, n, s[i], o) && d.isArray(s[i]) && (s[i] = Mc(s[i])), !a);
  }
  if (d.isFormData(e) && d.isFunction(e.entries)) {
    const r = {};
    return d.forEachEntry(e, (n, s) => {
      t(Lc(n), s, r, 0);
    }), r;
  }
  return null;
}
function Bc(e, t, r) {
  if (d.isString(e))
    try {
      return (t || JSON.parse)(e), d.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const xt = {
  transitional: to,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", s = n.indexOf("application/json") > -1, o = d.isObject(t);
    if (o && d.isHTMLForm(t) && (t = new FormData(t)), d.isFormData(t))
      return s ? JSON.stringify(ro(t)) : t;
    if (d.isArrayBuffer(t) || d.isBuffer(t) || d.isStream(t) || d.isFile(t) || d.isBlob(t) || d.isReadableStream(t))
      return t;
    if (d.isArrayBufferView(t))
      return t.buffer;
    if (d.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (o) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Dc(t, this.formSerializer).toString();
      if ((a = d.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const u = this.env && this.env.FormData;
        return Jt(
          a ? { "files[]": t } : t,
          u && new u(),
          this.formSerializer
        );
      }
    }
    return o || s ? (r.setContentType("application/json", !1), Bc(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || xt.transitional, n = r && r.forcedJSONParsing, s = this.responseType === "json";
    if (d.isResponse(t) || d.isReadableStream(t))
      return t;
    if (t && d.isString(t) && (n && !this.responseType || s)) {
      const i = !(r && r.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (i)
          throw a.name === "SyntaxError" ? T.from(a, T.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: H.classes.FormData,
    Blob: H.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
d.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  xt.headers[e] = {};
});
const Hc = d.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), zc = (e) => {
  const t = {};
  let r, n, s;
  return e && e.split(`
`).forEach(function(i) {
    s = i.indexOf(":"), r = i.substring(0, s).trim().toLowerCase(), n = i.substring(s + 1).trim(), !(!r || t[r] && Hc[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, bn = Symbol("internals");
function Xe(e) {
  return e && String(e).trim().toLowerCase();
}
function _t(e) {
  return e === !1 || e == null ? e : d.isArray(e) ? e.map(_t) : String(e);
}
function Vc(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const Wc = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function nr(e, t, r, n, s) {
  if (d.isFunction(n))
    return n.call(this, t, r);
  if (s && (t = r), !!d.isString(t)) {
    if (d.isString(n))
      return t.indexOf(n) !== -1;
    if (d.isRegExp(n))
      return n.test(t);
  }
}
function Jc(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function Gc(e, t) {
  const r = d.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(s, o, i) {
        return this[n].call(this, t, s, o, i);
      },
      configurable: !0
    });
  });
}
let G = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const s = this;
    function o(a, u, c) {
      const l = Xe(u);
      if (!l)
        throw new Error("header name must be a non-empty string");
      const f = d.findKey(s, l);
      (!f || s[f] === void 0 || c === !0 || c === void 0 && s[f] !== !1) && (s[f || u] = _t(a));
    }
    const i = (a, u) => d.forEach(a, (c, l) => o(c, l, u));
    if (d.isPlainObject(t) || t instanceof this.constructor)
      i(t, r);
    else if (d.isString(t) && (t = t.trim()) && !Wc(t))
      i(zc(t), r);
    else if (d.isHeaders(t))
      for (const [a, u] of t.entries())
        o(u, a, n);
    else
      t != null && o(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = Xe(t), t) {
      const n = d.findKey(this, t);
      if (n) {
        const s = this[n];
        if (!r)
          return s;
        if (r === !0)
          return Vc(s);
        if (d.isFunction(r))
          return r.call(this, s, n);
        if (d.isRegExp(r))
          return r.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = Xe(t), t) {
      const n = d.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || nr(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let s = !1;
    function o(i) {
      if (i = Xe(i), i) {
        const a = d.findKey(n, i);
        a && (!r || nr(n, n[a], a, r)) && (delete n[a], s = !0);
      }
    }
    return d.isArray(t) ? t.forEach(o) : o(t), s;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, s = !1;
    for (; n--; ) {
      const o = r[n];
      (!t || nr(this, this[o], o, t, !0)) && (delete this[o], s = !0);
    }
    return s;
  }
  normalize(t) {
    const r = this, n = {};
    return d.forEach(this, (s, o) => {
      const i = d.findKey(n, o);
      if (i) {
        r[i] = _t(s), delete r[o];
        return;
      }
      const a = t ? Jc(o) : String(o).trim();
      a !== o && delete r[o], r[a] = _t(s), n[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return d.forEach(this, (n, s) => {
      n != null && n !== !1 && (r[s] = t && d.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((s) => n.set(s)), n;
  }
  static accessor(t) {
    const n = (this[bn] = this[bn] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function o(i) {
      const a = Xe(i);
      n[a] || (Gc(s, i), n[a] = !0);
    }
    return d.isArray(t) ? t.forEach(o) : o(t), this;
  }
};
G.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
d.reduceDescriptors(G.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
d.freezeMethods(G);
function sr(e, t) {
  const r = this || xt, n = t || r, s = G.from(n.headers);
  let o = n.data;
  return d.forEach(e, function(a) {
    o = a.call(r, o, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), o;
}
function no(e) {
  return !!(e && e.__CANCEL__);
}
function Ge(e, t, r) {
  T.call(this, e ?? "canceled", T.ERR_CANCELED, t, r), this.name = "CanceledError";
}
d.inherits(Ge, T, {
  __CANCEL__: !0
});
function so(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new T(
    "Request failed with status code " + r.status,
    [T.ERR_BAD_REQUEST, T.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function Kc(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Qc(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let s = 0, o = 0, i;
  return t = t !== void 0 ? t : 1e3, function(u) {
    const c = Date.now(), l = n[o];
    i || (i = c), r[s] = u, n[s] = c;
    let f = o, g = 0;
    for (; f !== s; )
      g += r[f++], f = f % e;
    if (s = (s + 1) % e, s === o && (o = (o + 1) % e), c - i < t)
      return;
    const m = l && c - l;
    return m ? Math.round(g * 1e3 / m) : void 0;
  };
}
function Xc(e, t) {
  let r = 0, n = 1e3 / t, s, o;
  const i = (c, l = Date.now()) => {
    r = l, s = null, o && (clearTimeout(o), o = null), e.apply(null, c);
  };
  return [(...c) => {
    const l = Date.now(), f = l - r;
    f >= n ? i(c, l) : (s = c, o || (o = setTimeout(() => {
      o = null, i(s);
    }, n - f)));
  }, () => s && i(s)];
}
const Nt = (e, t, r = 3) => {
  let n = 0;
  const s = Qc(50, 250);
  return Xc((o) => {
    const i = o.loaded, a = o.lengthComputable ? o.total : void 0, u = i - n, c = s(u), l = i <= a;
    n = i;
    const f = {
      loaded: i,
      total: a,
      progress: a ? i / a : void 0,
      bytes: u,
      rate: c || void 0,
      estimated: c && a && l ? (a - i) / c : void 0,
      event: o,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, gn = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, wn = (e) => (...t) => d.asap(() => e(...t)), Yc = H.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, H.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(H.origin),
  H.navigator && /(msie|trident)/i.test(H.navigator.userAgent)
) : () => !0, Zc = H.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, s, o) {
      const i = [e + "=" + encodeURIComponent(t)];
      d.isNumber(r) && i.push("expires=" + new Date(r).toGMTString()), d.isString(n) && i.push("path=" + n), d.isString(s) && i.push("domain=" + s), o === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function el(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function tl(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function oo(e, t) {
  return e && !el(t) ? tl(e, t) : t;
}
const vn = (e) => e instanceof G ? { ...e } : e;
function je(e, t) {
  t = t || {};
  const r = {};
  function n(c, l, f, g) {
    return d.isPlainObject(c) && d.isPlainObject(l) ? d.merge.call({ caseless: g }, c, l) : d.isPlainObject(l) ? d.merge({}, l) : d.isArray(l) ? l.slice() : l;
  }
  function s(c, l, f, g) {
    if (d.isUndefined(l)) {
      if (!d.isUndefined(c))
        return n(void 0, c, f, g);
    } else return n(c, l, f, g);
  }
  function o(c, l) {
    if (!d.isUndefined(l))
      return n(void 0, l);
  }
  function i(c, l) {
    if (d.isUndefined(l)) {
      if (!d.isUndefined(c))
        return n(void 0, c);
    } else return n(void 0, l);
  }
  function a(c, l, f) {
    if (f in t)
      return n(c, l);
    if (f in e)
      return n(void 0, c);
  }
  const u = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: a,
    headers: (c, l, f) => s(vn(c), vn(l), f, !0)
  };
  return d.forEach(Object.keys(Object.assign({}, e, t)), function(l) {
    const f = u[l] || s, g = f(e[l], t[l], l);
    d.isUndefined(g) && f !== a || (r[l] = g);
  }), r;
}
const io = (e) => {
  const t = je({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: s, xsrfCookieName: o, headers: i, auth: a } = t;
  t.headers = i = G.from(i), t.url = eo(oo(t.baseURL, t.url), e.params, e.paramsSerializer), a && i.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let u;
  if (d.isFormData(r)) {
    if (H.hasStandardBrowserEnv || H.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((u = i.getContentType()) !== !1) {
      const [c, ...l] = u ? u.split(";").map((f) => f.trim()).filter(Boolean) : [];
      i.setContentType([c || "multipart/form-data", ...l].join("; "));
    }
  }
  if (H.hasStandardBrowserEnv && (n && d.isFunction(n) && (n = n(t)), n || n !== !1 && Yc(t.url))) {
    const c = s && o && Zc.read(o);
    c && i.set(s, c);
  }
  return t;
}, rl = typeof XMLHttpRequest < "u", nl = rl && function(e) {
  return new Promise(function(r, n) {
    const s = io(e);
    let o = s.data;
    const i = G.from(s.headers).normalize();
    let { responseType: a, onUploadProgress: u, onDownloadProgress: c } = s, l, f, g, m, p;
    function h() {
      m && m(), p && p(), s.cancelToken && s.cancelToken.unsubscribe(l), s.signal && s.signal.removeEventListener("abort", l);
    }
    let v = new XMLHttpRequest();
    v.open(s.method.toUpperCase(), s.url, !0), v.timeout = s.timeout;
    function x() {
      if (!v)
        return;
      const A = G.from(
        "getAllResponseHeaders" in v && v.getAllResponseHeaders()
      ), O = {
        data: !a || a === "text" || a === "json" ? v.responseText : v.response,
        status: v.status,
        statusText: v.statusText,
        headers: A,
        config: e,
        request: v
      };
      so(function(B) {
        r(B), h();
      }, function(B) {
        n(B), h();
      }, O), v = null;
    }
    "onloadend" in v ? v.onloadend = x : v.onreadystatechange = function() {
      !v || v.readyState !== 4 || v.status === 0 && !(v.responseURL && v.responseURL.indexOf("file:") === 0) || setTimeout(x);
    }, v.onabort = function() {
      v && (n(new T("Request aborted", T.ECONNABORTED, e, v)), v = null);
    }, v.onerror = function() {
      n(new T("Network Error", T.ERR_NETWORK, e, v)), v = null;
    }, v.ontimeout = function() {
      let I = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const O = s.transitional || to;
      s.timeoutErrorMessage && (I = s.timeoutErrorMessage), n(new T(
        I,
        O.clarifyTimeoutError ? T.ETIMEDOUT : T.ECONNABORTED,
        e,
        v
      )), v = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in v && d.forEach(i.toJSON(), function(I, O) {
      v.setRequestHeader(O, I);
    }), d.isUndefined(s.withCredentials) || (v.withCredentials = !!s.withCredentials), a && a !== "json" && (v.responseType = s.responseType), c && ([g, p] = Nt(c, !0), v.addEventListener("progress", g)), u && v.upload && ([f, m] = Nt(u), v.upload.addEventListener("progress", f), v.upload.addEventListener("loadend", m)), (s.cancelToken || s.signal) && (l = (A) => {
      v && (n(!A || A.type ? new Ge(null, e, v) : A), v.abort(), v = null);
    }, s.cancelToken && s.cancelToken.subscribe(l), s.signal && (s.signal.aborted ? l() : s.signal.addEventListener("abort", l)));
    const C = Kc(s.url);
    if (C && H.protocols.indexOf(C) === -1) {
      n(new T("Unsupported protocol " + C + ":", T.ERR_BAD_REQUEST, e));
      return;
    }
    v.send(o || null);
  });
}, sl = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), s;
    const o = function(c) {
      if (!s) {
        s = !0, a();
        const l = c instanceof Error ? c : this.reason;
        n.abort(l instanceof T ? l : new Ge(l instanceof Error ? l.message : l));
      }
    };
    let i = t && setTimeout(() => {
      i = null, o(new T(`timeout ${t} of ms exceeded`, T.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(o) : c.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", o));
    const { signal: u } = n;
    return u.unsubscribe = () => d.asap(a), u;
  }
}, ol = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, s;
  for (; n < r; )
    s = n + t, yield e.slice(n, s), n = s;
}, il = async function* (e, t) {
  for await (const r of al(e))
    yield* ol(r, t);
}, al = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, En = (e, t, r, n) => {
  const s = il(e, t);
  let o = 0, i, a = (u) => {
    i || (i = !0, n && n(u));
  };
  return new ReadableStream({
    async pull(u) {
      try {
        const { done: c, value: l } = await s.next();
        if (c) {
          a(), u.close();
          return;
        }
        let f = l.byteLength;
        if (r) {
          let g = o += f;
          r(g);
        }
        u.enqueue(new Uint8Array(l));
      } catch (c) {
        throw a(c), c;
      }
    },
    cancel(u) {
      return a(u), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, Gt = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", ao = Gt && typeof ReadableStream == "function", ul = Gt && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), uo = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, cl = ao && uo(() => {
  let e = !1;
  const t = new Request(H.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Sn = 64 * 1024, pr = ao && uo(() => d.isReadableStream(new Response("").body)), qt = {
  stream: pr && ((e) => e.body)
};
Gt && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !qt[t] && (qt[t] = d.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new T(`Response type '${t}' is not supported`, T.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const ll = async (e) => {
  if (e == null)
    return 0;
  if (d.isBlob(e))
    return e.size;
  if (d.isSpecCompliantForm(e))
    return (await new Request(H.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (d.isArrayBufferView(e) || d.isArrayBuffer(e))
    return e.byteLength;
  if (d.isURLSearchParams(e) && (e = e + ""), d.isString(e))
    return (await ul(e)).byteLength;
}, fl = async (e, t) => {
  const r = d.toFiniteNumber(e.getContentLength());
  return r ?? ll(t);
}, dl = Gt && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: s,
    cancelToken: o,
    timeout: i,
    onDownloadProgress: a,
    onUploadProgress: u,
    responseType: c,
    headers: l,
    withCredentials: f = "same-origin",
    fetchOptions: g
  } = io(e);
  c = c ? (c + "").toLowerCase() : "text";
  let m = sl([s, o && o.toAbortSignal()], i), p;
  const h = m && m.unsubscribe && (() => {
    m.unsubscribe();
  });
  let v;
  try {
    if (u && cl && r !== "get" && r !== "head" && (v = await fl(l, n)) !== 0) {
      let O = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), $;
      if (d.isFormData(n) && ($ = O.headers.get("content-type")) && l.setContentType($), O.body) {
        const [B, me] = gn(
          v,
          Nt(wn(u))
        );
        n = En(O.body, Sn, B, me);
      }
    }
    d.isString(f) || (f = f ? "include" : "omit");
    const x = "credentials" in Request.prototype;
    p = new Request(t, {
      ...g,
      signal: m,
      method: r.toUpperCase(),
      headers: l.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: x ? f : void 0
    });
    let C = await fetch(p);
    const A = pr && (c === "stream" || c === "response");
    if (pr && (a || A && h)) {
      const O = {};
      ["status", "statusText", "headers"].forEach((ye) => {
        O[ye] = C[ye];
      });
      const $ = d.toFiniteNumber(C.headers.get("content-length")), [B, me] = a && gn(
        $,
        Nt(wn(a), !0)
      ) || [];
      C = new Response(
        En(C.body, Sn, B, () => {
          me && me(), h && h();
        }),
        O
      );
    }
    c = c || "text";
    let I = await qt[d.findKey(qt, c) || "text"](C, e);
    return !A && h && h(), await new Promise((O, $) => {
      so(O, $, {
        data: I,
        headers: G.from(C.headers),
        status: C.status,
        statusText: C.statusText,
        config: e,
        request: p
      });
    });
  } catch (x) {
    throw h && h(), x && x.name === "TypeError" && /fetch/i.test(x.message) ? Object.assign(
      new T("Network Error", T.ERR_NETWORK, e, p),
      {
        cause: x.cause || x
      }
    ) : T.from(x, x && x.code, e, p);
  }
}), mr = {
  http: Rc,
  xhr: nl,
  fetch: dl
};
d.forEach(mr, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Cn = (e) => `- ${e}`, hl = (e) => d.isFunction(e) || e === null || e === !1, co = {
  getAdapter: (e) => {
    e = d.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const s = {};
    for (let o = 0; o < t; o++) {
      r = e[o];
      let i;
      if (n = r, !hl(r) && (n = mr[(i = String(r)).toLowerCase()], n === void 0))
        throw new T(`Unknown adapter '${i}'`);
      if (n)
        break;
      s[i || "#" + o] = n;
    }
    if (!n) {
      const o = Object.entries(s).map(
        ([a, u]) => `adapter ${a} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? o.length > 1 ? `since :
` + o.map(Cn).join(`
`) : " " + Cn(o[0]) : "as no adapter specified";
      throw new T(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: mr
};
function or(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Ge(null, e);
}
function xn(e) {
  return or(e), e.headers = G.from(e.headers), e.data = sr.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), co.getAdapter(e.adapter || xt.adapter)(e).then(function(n) {
    return or(e), n.data = sr.call(
      e,
      e.transformResponse,
      n
    ), n.headers = G.from(n.headers), n;
  }, function(n) {
    return no(n) || (or(e), n && n.response && (n.response.data = sr.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = G.from(n.response.headers))), Promise.reject(n);
  });
}
const lo = "1.7.9", Kt = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Kt[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const On = {};
Kt.transitional = function(t, r, n) {
  function s(o, i) {
    return "[Axios v" + lo + "] Transitional option '" + o + "'" + i + (n ? ". " + n : "");
  }
  return (o, i, a) => {
    if (t === !1)
      throw new T(
        s(i, " has been removed" + (r ? " in " + r : "")),
        T.ERR_DEPRECATED
      );
    return r && !On[i] && (On[i] = !0, console.warn(
      s(
        i,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(o, i, a) : !0;
  };
};
Kt.spelling = function(t) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function pl(e, t, r) {
  if (typeof e != "object")
    throw new T("options must be an object", T.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let s = n.length;
  for (; s-- > 0; ) {
    const o = n[s], i = t[o];
    if (i) {
      const a = e[o], u = a === void 0 || i(a, o, e);
      if (u !== !0)
        throw new T("option " + o + " must be " + u, T.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new T("Unknown option " + o, T.ERR_BAD_OPTION);
  }
}
const Tt = {
  assertOptions: pl,
  validators: Kt
}, ne = Tt.validators;
let Pe = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new yn(),
      response: new yn()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const o = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? o && !String(n.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + o) : n.stack = o;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = je(this.defaults, r);
    const { transitional: n, paramsSerializer: s, headers: o } = r;
    n !== void 0 && Tt.assertOptions(n, {
      silentJSONParsing: ne.transitional(ne.boolean),
      forcedJSONParsing: ne.transitional(ne.boolean),
      clarifyTimeoutError: ne.transitional(ne.boolean)
    }, !1), s != null && (d.isFunction(s) ? r.paramsSerializer = {
      serialize: s
    } : Tt.assertOptions(s, {
      encode: ne.function,
      serialize: ne.function
    }, !0)), Tt.assertOptions(r, {
      baseUrl: ne.spelling("baseURL"),
      withXsrfToken: ne.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let i = o && d.merge(
      o.common,
      o[r.method]
    );
    o && d.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete o[p];
      }
    ), r.headers = G.concat(i, o);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(r) === !1 || (u = u && h.synchronous, a.unshift(h.fulfilled, h.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(h) {
      c.push(h.fulfilled, h.rejected);
    });
    let l, f = 0, g;
    if (!u) {
      const p = [xn.bind(this), void 0];
      for (p.unshift.apply(p, a), p.push.apply(p, c), g = p.length, l = Promise.resolve(r); f < g; )
        l = l.then(p[f++], p[f++]);
      return l;
    }
    g = a.length;
    let m = r;
    for (f = 0; f < g; ) {
      const p = a[f++], h = a[f++];
      try {
        m = p(m);
      } catch (v) {
        h.call(this, v);
        break;
      }
    }
    try {
      l = xn.call(this, m);
    } catch (p) {
      return Promise.reject(p);
    }
    for (f = 0, g = c.length; f < g; )
      l = l.then(c[f++], c[f++]);
    return l;
  }
  getUri(t) {
    t = je(this.defaults, t);
    const r = oo(t.baseURL, t.url);
    return eo(r, t.params, t.paramsSerializer);
  }
};
d.forEach(["delete", "get", "head", "options"], function(t) {
  Pe.prototype[t] = function(r, n) {
    return this.request(je(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
d.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(o, i, a) {
      return this.request(je(a || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: i
      }));
    };
  }
  Pe.prototype[t] = r(), Pe.prototype[t + "Form"] = r(!0);
});
let ml = class fo {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners) return;
      let o = n._listeners.length;
      for (; o-- > 0; )
        n._listeners[o](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let o;
      const i = new Promise((a) => {
        n.subscribe(a), o = a;
      }).then(s);
      return i.cancel = function() {
        n.unsubscribe(o);
      }, i;
    }, t(function(o, i, a) {
      n.reason || (n.reason = new Ge(o, i, a), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new fo(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
};
function yl(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function bl(e) {
  return d.isObject(e) && e.isAxiosError === !0;
}
const yr = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(yr).forEach(([e, t]) => {
  yr[t] = e;
});
function ho(e) {
  const t = new Pe(e), r = Bs(Pe.prototype.request, t);
  return d.extend(r, Pe.prototype, t, { allOwnKeys: !0 }), d.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(s) {
    return ho(je(e, s));
  }, r;
}
const D = ho(xt);
D.Axios = Pe;
D.CanceledError = Ge;
D.CancelToken = ml;
D.isCancel = no;
D.VERSION = lo;
D.toFormData = Jt;
D.AxiosError = T;
D.Cancel = D.CanceledError;
D.all = function(t) {
  return Promise.all(t);
};
D.spread = yl;
D.isAxiosError = bl;
D.mergeConfig = je;
D.AxiosHeaders = G;
D.formToJSON = (e) => ro(d.isHTMLForm(e) ? new FormData(e) : e);
D.getAdapter = co.getAdapter;
D.HttpStatusCode = yr;
D.default = D;
const {
  Axios: $l,
  AxiosError: kl,
  CanceledError: Fl,
  isCancel: Ul,
  CancelToken: Nl,
  VERSION: ql,
  all: Dl,
  Cancel: Ll,
  isAxiosError: Ml,
  spread: Bl,
  toFormData: Hl,
  AxiosHeaders: zl,
  HttpStatusCode: Vl,
  formToJSON: Wl,
  getAdapter: Jl,
  mergeConfig: Gl
} = D, gl = 3e4;
class wl {
  constructor(t) {
    _(this, "axiosInstance");
    _(this, "getAccessToken");
    const { baseURL: r, defaultHeaders: n, timeout: s, getAccessToken: o } = t;
    this.axiosInstance = D.create({
      baseURL: r,
      headers: n,
      timeout: s ?? gl
    }), this.getAccessToken = o;
  }
  /**
   * Executes a request with the provided options, automatically injecting a Bearer token if missing.
   */
  async executeRequest(t) {
    const {
      method: r,
      route: n,
      pathParams: s = [],
      data: o,
      headers: i,
      responseType: a
    } = t;
    if (!n)
      throw new Error("Route is required");
    const u = s.length > 0 ? `/${s.join("/")}` : "", c = {
      ...this.axiosInstance.defaults.headers.common,
      ...i
    };
    if (!c.Authorization && this.getAccessToken)
      try {
        const g = await this.getAccessToken();
        g && (c.Authorization = `Bearer ${g}`);
      } catch (g) {
        throw new Error(`Failed to acquire access token: ${g}`);
      }
    const l = {
      method: r,
      url: `${n}${u}`,
      data: o,
      headers: c,
      responseType: a
    }, f = await this.axiosInstance(
      l
    );
    return {
      data: f.data,
      status: f.status
    };
  }
}
const vl = "https://apim-really-test.azure-api.net", El = "3a7c292724d9422f8bd6c88e86cee633";
class Sl {
  create(t, r) {
    const n = t.startsWith("/") ? t : `/${t}`;
    return new wl({
      baseURL: `${vl}${n}`,
      defaultHeaders: {
        "Ocp-Apim-Subscription-Key": El
      },
      getAccessToken: r
    });
  }
}
const Kl = /* @__PURE__ */ He({
  __name: "SpecialComponent",
  props: {
    color: {},
    where: {}
  },
  setup(e) {
    return (t, r) => (Z(), fe("div", null, "Special component 2: " + rt(t.where), 1));
  }
}), Ql = new Sl();
export {
  wl as A,
  _l as C,
  Tl as U,
  Kl as _,
  Ql as a,
  Ho as c,
  zo as g,
  Il as u
};
